var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgFlipBack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 212,
    viewBox: "0 0 342 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_397)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "url(#paint0_linear_150_397)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447 122.094C545 395.094 252.28 380.594 112 380.594C-28.2803 380.594 -142 272.023 -142 138.094C-142 4.16454 -64.2803 183.094 76 183.094C217.5 190.094 349 -84.4063 447 122.094Z",
    fill: "#EA5086"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_150_397)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.67
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.428 162.824C191.413 162.65 186.75 164.944 220.149 175.799C253.553 186.655 267.329 184.493 307.674 174.24C348.02 163.992 281.468 167.063 281.468 167.063L202.428 162.824Z",
    fill: "#622252"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.922 171.259C302.922 171.259 301.214 171.028 300.369 172.813C300.369 172.813 298.278 171.966 298.311 171.773C298.344 171.584 300.619 169.488 300.619 169.488L303.101 170.313L302.927 171.254L302.922 171.259Z",
    fill: "#60001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.718 98.6525C229.956 102.359 238.088 105.397 237.021 110.059C235.955 114.721 227.903 111.302 228.125 116.633C228.328 121.522 239.102 119.991 241.391 112.296C243.68 104.596 237.002 95.4123 233.718 98.6525Z",
    fill: "url(#paint1_linear_150_397)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_150_397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 228,
    y: 97,
    width: 14,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.718 98.6525C229.956 102.359 238.088 105.397 237.021 110.059C235.955 114.721 227.903 111.302 228.125 116.633C228.328 121.522 239.102 119.991 241.391 112.296C243.68 104.596 237.002 95.4123 233.718 98.6525Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_150_397)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.708 113.888L240.556 114.265C240.896 113.662 241.179 113.002 241.391 112.296C241.835 110.798 241.939 109.244 241.797 107.737L241.528 107.728L200.762 81.9525L267.239 75.2368L310.369 111.024L314.315 111.787L320.294 103.663L319.36 102.736C321.672 98.8786 334.768 75.2839 320.294 57.4489C317.982 54.5996 315.395 52.4521 312.653 50.8744C296.947 43.391 279.391 53.102 275.861 57.5761L272.388 55.8382C272.336 55.8806 272.279 55.9277 272.232 55.9701L271.798 55.5415C271.798 55.5415 267.753 62.5305 267.178 72.2415L193.83 80.6857L238.857 108.999C238.857 108.999 239.617 112.941 233.708 113.893V113.888ZM285.866 69.5053C288.679 67.0752 304.432 54.2653 313.106 64.1788C322.951 75.4251 315.164 90.0718 311.823 95.2617L285.866 69.5053Z",
    fill: "#9F1F56"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.921 123.947L294.748 169.079L263.166 172.893L208.492 161.751L202.48 118.235L309.921 123.947Z",
    fill: "url(#paint2_linear_150_397)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M232.439 58.8805L292.709 47.9261C292.709 47.9261 313.446 58.6215 313.828 59.4786C314.211 60.3357 320.157 75.5711 320.063 77.1911C319.968 78.8112 315.763 97.0936 315.192 97.475C314.621 97.8565 309.185 109.951 309.185 109.951L240.41 107.728L196.859 79.6259L211.522 62.9542L227.823 58.6544L232.434 58.8758L232.439 58.8805Z",
    fill: "url(#paint3_linear_150_397)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M307.674 91.1454L305.437 90.2883C305.437 90.2883 304.092 92.7184 304.073 89.6195C304.054 86.5254 301.893 87.3825 301.893 87.3825L301.468 84.9854L299.189 84.1471C299.189 84.1471 297.613 86.1957 297.471 84.1471C297.329 82.0984 296.041 86.0968 296.041 86.0968L305.39 93.4296L307.443 92.0497L307.674 91.1454Z",
    fill: "#411B2F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.11
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M297.263 99.6084C252.099 100.249 248.267 98.9962 250.136 101.949C252.005 104.902 268.924 108.33 278.834 108.33C288.745 108.33 321.441 99.2693 297.268 99.6084H297.263Z",
    fill: "#FF8E4A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.11
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M293.988 94.5222C287.881 96.9994 280.533 97.9507 269.179 94.5222C257.824 91.0936 289.406 90.5238 294.559 91.4751C299.713 92.4264 293.988 94.5222 293.988 94.5222Z",
    fill: "#FF8E4A"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.048 139.785C301.048 139.785 275.507 141.307 263.737 141.561C263.737 141.561 222.835 135.909 202.924 131.657L203.877 132.862C203.877 132.862 243.921 138.702 258.503 142.446C258.503 142.446 292.426 140.478 300.251 141.429C308.075 142.38 296.499 151.842 296.499 151.842C296.499 151.842 281.194 154.121 258.343 154.63C258.343 154.63 215.076 147.203 203.877 143.332L204.514 144.73L259.093 155.713L297.514 152.666L302.648 146.068L303.748 141.118L301.044 139.785H301.048Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M317.911 87.3496L316.311 87.9336C316.311 87.9336 293.412 63.5524 288.353 60.4724C283.294 57.3923 276.81 54.058 276.81 54.058L278.83 52.7252C308.109 46.2496 291.124 61.0093 291.124 61.0093C291.124 61.0093 308.491 79.2916 316.887 86.5302L319.784 77.8741C319.784 77.8741 309.128 65.6152 301.888 58.6969C294.649 51.7786 302.408 58.2542 302.408 58.2542C302.408 58.2542 314.182 71.3043 318.779 74.6339C323.376 77.9635 317.911 87.359 317.911 87.359V87.3496Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68,
    d: "M296.499 151.846C296.499 151.846 281.194 154.126 258.343 154.635C258.343 154.635 215.543 147.288 204.066 143.402L203.877 142.988C215.071 146.859 258.343 154.286 258.343 154.286C281.194 153.773 296.499 151.498 296.499 151.498C296.499 151.498 302.71 146.421 302.96 143.332C303.205 146.369 296.499 151.846 296.499 151.846Z",
    fill: "url(#paint4_linear_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68,
    d: "M263.737 141.561C263.737 141.561 223.283 135.975 203.254 131.727L202.919 131.308C222.83 135.561 263.732 141.212 263.732 141.212C275.503 140.958 301.044 139.437 301.044 139.437L303.748 140.77L303.677 141.085L301.044 139.79C301.044 139.79 275.503 141.311 263.732 141.566L263.737 141.561Z",
    fill: "url(#paint5_linear_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68,
    d: "M318.779 74.6244C314.182 71.2947 302.408 58.2446 302.408 58.2446C302.408 58.2446 301.015 57.0814 299.958 56.2666C296.74 53.0077 302.596 57.8914 302.596 57.8914C302.596 57.8914 314.371 70.9415 318.968 74.2712C323.347 77.4454 318.6 86.1156 318.142 86.9256C319.128 85.0701 322.795 77.5301 318.779 74.6197V74.6244Z",
    fill: "url(#paint6_linear_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68,
    d: "M291.124 61.0044C291.124 61.0044 291.227 60.915 291.407 60.7501C292.742 62.1536 308.953 79.1549 317.023 86.125L316.891 86.5253C308.495 79.2868 291.128 61.0044 291.128 61.0044H291.124Z",
    fill: "url(#paint7_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M300.251 141.085C292.426 140.134 258.503 142.102 258.503 142.102C243.921 138.358 203.877 132.519 203.877 132.519L203.254 131.732C223.283 135.975 263.737 141.566 263.737 141.566C275.507 141.311 301.048 139.79 301.048 139.79L303.682 141.085L302.653 145.719L297.518 152.317L259.098 155.365L204.519 144.382L204.07 143.398C215.548 147.288 258.348 154.63 258.348 154.63C281.199 154.116 296.504 151.842 296.504 151.842C296.504 151.842 303.21 146.365 302.964 143.327C303.054 142.201 302.351 141.335 300.26 141.081L300.251 141.085Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M299.807 98.8973C299.807 98.8973 264.369 98.9915 247.455 98.9679C247.455 98.9679 217.176 78.3261 208.78 74.7045C200.385 71.0876 210.404 73.7532 210.404 73.7532C210.404 73.7532 235.888 91.1078 248.055 97.8706C248.055 97.8706 284.545 99.3683 300.671 97.5127L293.417 90.293L291.605 88.7059L285.526 86.8927C285.526 86.8927 263.6 86.808 250.169 88.2302C250.169 88.2302 230.621 74.0404 224.949 71.0876C219.276 68.1347 225.435 69.849 225.435 69.849C225.435 69.849 243.652 82.7342 250.16 86.8927C250.16 86.8927 266.21 87.2412 285.871 85.8284C305.536 84.4155 302.195 99.3683 302.195 99.3683L299.812 98.8973H299.807Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68,
    d: "M302.408 96.7686C302.337 92.5536 300.289 84.7923 285.871 85.8284C266.205 87.2413 250.16 86.8928 250.16 86.8928C243.652 82.7343 225.435 69.849 225.435 69.849C225.435 69.849 223.462 69.3027 222.783 69.3592C221.598 68.3514 225.435 69.4204 225.435 69.4204C225.435 69.4204 243.652 82.3057 250.16 86.4642C250.16 86.4642 266.21 86.8127 285.871 85.3999C300.794 84.3308 302.469 92.6808 302.408 96.7686Z",
    fill: "url(#paint8_linear_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68,
    d: "M248.05 97.8707C235.883 91.1079 210.399 73.7533 210.399 73.7533C210.399 73.7533 206.855 72.8114 205.75 72.8067C203.924 71.601 210.399 73.3247 210.399 73.3247C210.399 73.3247 235.883 90.6793 248.05 97.4422C248.05 97.4422 283.964 98.9163 300.279 97.1266L300.666 97.5128C284.54 99.3684 248.05 97.8707 248.05 97.8707Z",
    fill: "url(#paint9_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.43 69.849C225.43 69.849 243.647 82.7342 250.155 86.8928C250.155 86.8928 266.205 87.2413 285.866 85.8284C300.284 84.7923 302.337 92.5536 302.403 96.7686C302.384 98.0685 302.19 98.9397 302.19 98.9397L299.807 98.4688C299.807 98.4688 264.369 98.563 247.455 98.5394C247.455 98.5394 217.176 77.8976 208.78 74.2759C207.133 73.5648 206.199 73.0986 205.755 72.8066C206.859 72.8066 210.404 73.7532 210.404 73.7532C210.404 73.7532 235.888 91.1078 248.055 97.8707C248.055 97.8707 284.545 99.3683 300.671 97.5127L300.284 97.1266C300.411 97.1124 300.543 97.0983 300.671 97.0842L293.417 89.8645L291.605 88.2774L285.526 86.4642C285.526 86.4642 263.6 86.3794 250.169 87.8017C250.169 87.8017 230.621 73.6119 224.949 70.659C223.759 70.0374 223.094 69.6276 222.778 69.3592C223.462 69.3027 225.43 69.849 225.43 69.849Z",
    fill: "#9F008D"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M316.504 87.5803C316.504 87.5803 293.606 63.1991 288.547 60.1191C283.997 57.3452 278.287 54.3688 277.192 53.8036L278.83 52.7204C295.829 48.9622 297.231 52.3578 295.418 55.8711C294.031 58.2918 291.312 60.656 291.312 60.656C291.312 60.656 291.345 60.6889 291.402 60.7502C291.223 60.915 291.119 61.0045 291.119 61.0045C291.119 61.0045 308.486 79.2868 316.882 86.5254L317.014 86.1251C317.014 86.1251 317.052 86.158 317.071 86.1769L319.968 77.5208C319.968 77.5208 309.312 65.2619 302.073 58.3436C301.124 57.4394 300.435 56.7659 299.949 56.2714C301.001 57.0862 302.398 58.2494 302.398 58.2494C302.398 58.2494 314.173 71.2995 318.77 74.6291C322.786 77.5396 319.119 85.0796 318.133 86.9351C318.109 86.9775 318.095 87.001 318.095 87.001L316.495 87.585L316.504 87.5803Z",
    fill: "#9F008D"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M314.036 92.9916C318.028 81.571 307.349 70.6826 296.706 70.6072C286.064 70.5272 286.253 75.4816 286.253 75.4816C286.253 75.4816 311.903 92.6478 288.924 92.0167C265.946 91.3857 254.204 91.4092 248.045 97.8707C241.882 104.332 198.983 82.1456 198.983 82.1456C198.983 82.1456 220.819 70.8757 220.999 70.6072C221.178 70.3388 283.072 57.4159 283.072 57.4159L311.818 56.8177L320.803 65.2996C320.803 65.2996 321.936 80.1581 322.224 81.199C322.512 82.235 317.642 93.4767 317.642 93.4767L314.031 92.9916H314.036Z",
    fill: "url(#paint10_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.922 87.5803C271.085 87.7687 250.169 88.6493 250.169 88.6493C250.169 88.6493 226.336 88.249 214.741 77.8645C203.145 67.48 276.045 65.0829 276.045 65.0829L284.918 87.5803H284.922Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.084 154.828L209.795 126.137L218.002 127.757L219.927 131.026C219.927 131.026 222.391 134.454 231.358 132.801L231.613 128.864L251.967 132.099L265.172 166.38L266.857 165.716L270.675 133.051L296.881 134.002L292.62 163.201C292.62 163.201 295.928 164.091 295.862 161.868C295.8 159.645 303.097 125.115 303.097 125.115L197.166 118.414L208.964 155.713L213.084 154.823V154.828Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M305.532 126.707L263.166 127.658V170.317L298.576 165.876L305.532 126.707Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M313.106 100.621L278.433 66.9103L303.243 56.8177L320.289 63.8632L323.664 83.2099L313.106 100.621Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M210.314 147.594C209.479 134.581 210.116 125.44 220.612 129.311C231.108 133.183 226.53 128.162 237.342 130.512C248.154 132.862 252.609 151.526 252.609 151.526C252.609 151.526 260.287 168.603 266.083 151.526C271.883 134.45 281.93 132.227 288.929 136.103C295.928 139.974 294.715 156.693 294.715 156.693C294.715 156.693 304.385 129.311 304.196 128.93C304.007 128.548 303.37 126.834 302.096 126.137C300.822 125.44 200.823 118.202 200.823 118.202L205.406 150.005L210.314 147.594Z",
    fill: "url(#paint11_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M241.528 107.728C241.528 107.728 262.071 87.2649 239.815 68.1348L197.411 80.2712L241.523 107.728H241.528Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M269.367 53.1584C258.164 57.8821 229.078 62.86 223.486 62.9542C217.889 63.0484 222.377 60.8962 234.062 58.6874C245.752 56.4786 273.185 51.5478 269.367 53.1584Z",
    fill: "#FFA94A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M243.699 140.266C212.207 136.041 209.569 132.9 212.447 138.42C215.444 144.165 224.42 148.705 235.775 146.134C247.13 143.562 253.19 141.537 243.694 140.266H243.699Z",
    fill: "#FFA94A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M234.968 151.799C218.974 148.559 212.211 145.993 213.594 148.512C214.977 151.036 218.79 155.511 222.92 156.226C227.049 156.942 241.509 153.123 234.968 151.799Z",
    fill: "#FFA94A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M295.371 78.9384C295.371 78.9384 291.393 69.8961 291.256 68.9259C291.124 67.9558 303.941 59.7989 311.063 66.1473C317.217 71.6339 317.439 81.7641 310.482 94.8095C303.526 107.855 319.341 96.2694 319.355 95.9209C319.369 95.5724 322.993 73.1928 322.993 72.2414C322.993 71.2901 310.742 56.4363 309.902 56.149C309.062 55.8617 286.22 57.463 285.522 57.9009C284.828 58.3389 278.433 71.0405 278.433 71.0405L295.371 78.9384Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M231.721 125.652L231.358 132.801C231.358 132.801 222.872 134.515 219.927 131.026C216.982 127.536 217.667 120.74 217.667 120.74L232.471 123.914L231.721 125.652Z",
    fill: "#9F008D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M248.272 97.1878C251.755 88.7012 297.263 90.844 297.263 90.844L271.184 69.5099L196.293 78.2696L200.762 81.9572L241.528 107.732C241.528 107.732 245.067 104.996 248.272 97.1925V97.1878Z",
    fill: "#9F008D"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M205.916 73.2869C205.916 73.2869 210.21 60.1473 231.49 59.1631L233.557 58.8758C233.557 58.8758 230.475 58.499 223.76 58.8146C213.991 59.2667 203.339 65.827 200.574 72.2414C195 85.1596 205.916 73.2869 205.916 73.2869Z",
    fill: "url(#paint12_linear_150_397)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M217.766 155.958C214.156 156.65 212.551 154.701 212.551 154.701L211.565 155.963L216.506 159.749L217.766 155.958Z",
    fill: "#60001B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M206.015 67.838C206.015 67.838 214.835 59.5681 226.19 58.6921C226.19 58.6921 231.074 58.6498 233.552 58.8805C233.552 58.8805 230.933 59.1631 225.666 60.1286C213.953 62.2714 208.45 69.3357 206.015 73.0279C195.996 88.2209 206.015 67.8427 206.015 67.8427V67.838Z",
    fill: "#9F1F56"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M213.495 61.2919C213.495 61.2919 207.435 64.3436 204.42 68.1348L203.311 68.4786C203.311 68.4786 205.363 64.8193 213.495 61.2919Z",
    fill: "url(#paint13_linear_150_397)"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M194.684 110.765C194.684 110.765 276.899 113.276 312.115 116.897L309.925 118.706L240.938 118.414L194.688 110.765H194.684Z",
    fill: "#420031"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M227.242 113.502C227.242 113.502 229.149 115.583 233.708 113.888L231.296 117.66L226.969 115.578L227.238 113.497L227.242 113.502Z",
    fill: "#60001B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M216.879 112.805C216.879 112.805 217.601 113.817 219.153 112.969L217.841 114.834L216.879 114.443V112.809V112.805Z",
    fill: "#60001B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_150_397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 191,
    y: 47,
    width: 137,
    height: 133
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M256.583 179.906L300.369 172.818C300.142 171.725 300.095 170.605 300.888 170.638C301.577 170.666 302.318 170.953 302.922 171.259L306.041 162.763L303.37 162.255L311.001 130.64L313.673 130.508C313.673 130.508 314.565 127.842 315.405 123.25C317.915 121.918 320.138 119.761 321.115 116.784C322.465 112.682 321.318 108.203 319.298 105.001L320.289 103.654L319.355 102.726C321.667 98.8691 334.763 75.2744 320.289 57.4395C305.499 39.223 279.538 49.5369 272.223 55.9607L271.788 55.5321L254.766 58.7157C250.23 64.3436 246.771 60.2087 246.771 60.2087L198.407 69.2557C194.972 73.7015 193.825 80.681 193.825 80.681L200.757 81.9525L267.234 75.2368L310.364 111.024L314.31 111.787L315.022 110.817C315.636 111.886 315.962 113.021 315.645 114.26C315.282 115.696 314.267 116.45 312.993 116.916C302.054 116.662 265.969 115.729 233.703 113.883C233.703 113.883 229.366 117.312 228.252 115.39C227.738 114.505 227.427 113.897 227.238 113.497C224.491 113.327 221.787 113.148 219.149 112.96C218.771 113.695 217.851 114.99 216.874 112.795C207.685 112.126 199.342 111.368 192.683 110.511L191.408 111.783L193.192 120.797H194.844L202.607 152.661H200.191L202.735 164.214L256.583 179.896V179.906ZM251.967 164.223L217.761 155.958C216.945 156.792 215.694 157.644 214.212 157.272C212.782 156.914 212.499 155.727 212.546 154.696L211.508 154.446L205.911 122.45L250.948 128.035L251.962 164.218L251.967 164.223ZM311.823 95.2617L307.67 91.1408C306.863 91.6589 305.437 92.4124 304.508 92.0121C303.625 91.6306 303.885 89.2853 304.177 87.6746L301.464 84.9808C300.289 85.5318 298.571 86.144 297.849 85.4046C297.145 84.6841 297.58 82.8615 298.019 81.5616L285.862 69.5006C288.674 67.0704 304.427 54.2605 313.102 64.1741C322.946 75.4204 315.159 90.067 311.818 95.2569L311.823 95.2617ZM265.582 165.876L266.852 129.312L300.572 130.197L293.445 162.448L265.582 165.876Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_150_397)"
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M319.02 103.282C319.02 103.282 336.099 76.9227 320.294 57.4489C304.012 37.391 274.176 51.9246 270.613 57.7644C267.05 63.6042 285.437 69.8914 285.437 69.8914C285.437 69.8914 303.564 53.2715 313.111 64.1788C325.282 78.086 310.501 97.1878 310.501 97.1878L319.024 103.282H319.02Z",
    fill: "url(#paint14_linear_150_397)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M193.83 80.6856C193.83 80.6856 194.976 73.7014 198.412 69.2603L271.793 55.5415L320.289 103.663L314.31 111.787L310.364 111.024L267.234 75.2367L200.762 81.9525L241.528 107.728V109.249L238.857 108.995L193.83 80.6856Z",
    fill: "url(#paint15_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M310.369 111.029L267.239 75.2415L200.762 81.9526L241.528 107.728V109.249L238.857 108.995L193.83 80.6858L267.173 72.2416L309.251 106.711C309.251 106.711 304.956 100.329 310.586 99.472C316.216 98.6149 319.747 104.328 319.747 104.328C319.784 104.346 314.31 111.787 314.31 111.787L310.364 111.025L310.369 111.029Z",
    fill: "#9F1F56"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M233.708 113.888L240.556 114.265C240.896 113.662 241.179 113.002 241.391 112.296C241.835 110.798 241.939 109.244 241.797 107.737L241.528 107.728L200.762 81.9525L267.239 75.2368L310.369 111.024L314.315 111.787L320.294 103.663L319.36 102.736C321.672 98.8786 334.768 75.2839 320.294 57.4489C317.982 54.5996 315.395 52.4521 312.653 50.8744C296.947 43.391 279.391 53.102 275.861 57.5761L272.388 55.8382C272.336 55.8806 272.279 55.9277 272.232 55.9701L271.798 55.5415C271.798 55.5415 267.753 62.5305 267.178 72.2415L193.83 80.6857L238.857 108.999C238.857 108.999 239.617 112.941 233.708 113.893V113.888ZM285.866 69.5053C288.679 67.0752 304.432 54.2653 313.106 64.1788C322.951 75.4251 315.164 90.0718 311.823 95.2617L285.866 69.5053Z",
    fill: "#9F1F56"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M191.408 111.792L193.192 120.806H194.844L202.607 152.671H200.191L202.735 164.223L256.583 179.906L302.478 172.479L306.041 162.768L303.37 162.259L311.001 130.644L313.673 130.513C313.673 130.513 315.405 125.332 316.311 116.991C316.311 116.991 229.196 115.216 192.683 110.516L191.408 111.787V111.792ZM265.582 165.876L266.852 129.312L300.572 130.197L293.446 162.448L265.582 165.876ZM205.916 122.455L250.952 128.04L251.967 164.223L211.513 154.446L205.916 122.45V122.455Z",
    fill: "url(#paint16_linear_150_397)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.53,
    d: "M315.664 122.313L266.857 129.312L313.677 130.513L315.664 122.313Z",
    fill: "url(#paint17_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M310.487 117.721C302.19 118.329 301.332 123.279 304.003 125.657C306.674 128.035 314.947 125.568 314.947 125.568L316.013 119.436L310.487 117.721Z",
    fill: "#773960"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M311.511 101.379C306.806 105.571 316.981 108.995 315.645 114.265C314.31 119.535 304.234 115.668 304.512 121.692C304.767 127.216 318.25 125.487 321.115 116.789C323.98 108.09 315.626 97.7153 311.511 101.375V101.379Z",
    fill: "url(#paint18_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M274.988 172.39C274.535 176.209 271.213 176.51 270.123 175.601C269.037 174.693 268.943 171.499 269.249 170.727C269.556 169.95 274.983 172.39 274.983 172.39H274.988Z",
    fill: "#9F008D"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M271.694 168.763C267.937 169.14 268.353 175.032 272.322 174.627C276.291 174.222 275.97 168.339 271.694 168.763Z",
    fill: "#860409"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M273.436 171.669C270.108 172.032 270.132 170.228 271.18 169.211C272.227 168.193 273.922 169.229 274.299 169.795C274.677 170.355 274.667 171.537 273.436 171.669Z",
    fill: "#FFFFC4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M273.922 171.999C271.973 170.925 270.023 173.831 271.798 174.316C273.577 174.801 275.791 173.03 273.922 171.999Z",
    fill: "#B73700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75,
    d: "M305.532 163.018L302.653 166.988L265.172 178.517L302.478 172.474L306.041 162.763L305.532 163.018Z",
    fill: "url(#paint19_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M294.701 169.498C294.248 173.317 290.925 173.619 289.835 172.71C288.75 171.801 288.655 168.608 288.962 167.835C289.269 167.058 294.696 169.498 294.696 169.498H294.701Z",
    fill: "#9F008D"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M291.412 165.872C287.656 166.248 288.071 172.14 292.04 171.735C296.009 171.33 295.688 165.448 291.412 165.872Z",
    fill: "#860409"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M293.148 168.777C289.821 169.14 289.845 167.336 290.892 166.319C291.94 165.302 293.634 166.338 294.012 166.903C294.389 167.463 294.38 168.645 293.148 168.777Z",
    fill: "#FFFFC4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M293.639 169.107C291.69 168.033 289.736 170.939 291.515 171.424C293.295 171.909 295.508 170.138 293.639 169.107Z",
    fill: "#B73700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M193.192 120.806H194.844L203.721 122.454L208.875 154.512L211.513 154.446L205.916 122.45L250.952 128.035L258.683 129.307L258.083 167.934L256.106 168.104L256.583 179.901L302.478 172.474L306.041 162.763L303.37 162.255L311.001 130.64L313.673 130.508C313.673 130.508 314.565 127.842 315.405 123.25C317.915 121.918 320.138 119.761 321.115 116.784C323.98 108.086 315.626 97.7106 311.511 101.37C307.273 105.142 315.098 108.298 315.726 112.734L318.316 113.747C318.316 113.747 318.505 117.966 312.686 119.426C306.867 120.886 306.244 118.607 306.948 118.258C307.651 117.91 311.492 117.886 313.281 116.935L312.998 116.907C304.729 116.713 282.119 116.134 257.649 115.07C257.626 115.07 256.196 127.268 256.196 127.268L193.037 120.01L193.192 120.806ZM265.582 165.876L266.852 129.311L300.572 130.197L293.445 162.448L265.582 165.876Z",
    fill: "#9F1F56"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M313.106 64.1788C326.023 77.0641 314.456 95.808 314.456 95.808L319.359 102.736L311.827 95.2617C315.164 90.0718 322.956 75.4252 313.111 64.1788H313.106Z",
    fill: "#9F1F56"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M313.677 130.512L311.016 130.381L257.371 127.753L259.296 129.133L266.857 129.312L300.572 130.202L293.446 162.448L265.583 165.876L267.461 166.988L296.74 163.164L304.102 131.181L313.677 130.512Z",
    fill: "#9F1F56"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M271.793 55.5415L285.866 69.5052L275.857 57.576L271.793 55.5415Z",
    fill: "#B21946"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M271.397 56.2903C271.397 56.2903 251.637 64.7769 244.435 65.2996L245.747 60.4112L271.793 55.5415L271.397 56.2903Z",
    fill: "url(#paint20_linear_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75,
    d: "M326.08 74.7799C325.06 79.0138 318.699 88.6165 316.094 91.0325C313.484 93.4438 311.827 95.2664 311.827 95.2664L319.359 102.74C319.359 102.74 323.989 94.6447 325.768 86.9352C327.548 79.2257 326.424 73.3718 326.085 74.7846L326.08 74.7799Z",
    fill: "url(#paint21_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.76
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M298.127 50.898C297.764 50.0361 296.395 50.5965 297.094 51.3736C297.792 52.1507 298.306 51.3218 298.127 50.898Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.76
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M298.127 58.8948C297.764 58.0329 296.395 58.5934 297.094 59.3704C297.792 60.1522 298.306 59.3186 298.127 58.8948Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.53,
    d: "M314.036 111.736L292.162 95.921L310.369 111.029L314.036 111.736Z",
    fill: "url(#paint22_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M306.041 162.763L303.37 162.255L260.622 168.109L306.041 162.763Z",
    fill: "#FFF700"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.76
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M262.477 57.284L271.793 55.5415C271.793 55.5415 267.796 62.959 267.366 70.0186C267.366 70.0186 265.781 65.1631 267.47 60.6749C267.635 60.2416 267.829 59.813 268.055 59.3986C268.489 56.7801 262.477 57.284 262.477 57.284Z",
    fill: "#D2BEB3"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M295.281 47.2952C295.281 47.2952 285.163 47.2434 272.383 55.8382L273.388 56.3422C273.388 56.3422 281.595 48.8823 295.281 47.2952Z",
    fill: "url(#paint23_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.76
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M300.43 61.1129L301.478 48.157L293.497 47.54L292.318 47.6766L300.331 48.2465L299.515 61.3907L300.43 61.1129Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M300.43 61.1129L301.478 48.157L302.577 48.2182L300.713 61.0375L300.43 61.1129Z",
    fill: "#FFF700"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M319.284 109.758C318.954 113.186 311.256 105.519 311.162 103.282C311.067 101.045 313.479 99.7498 316.188 101.61C318.892 103.47 319.581 106.663 319.284 109.758Z",
    fill: "#FFA400"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M315.254 119.205C310.822 120.439 308.302 119.855 306.631 120.472C304.961 121.089 304.149 125.412 309.926 124.847C315.697 124.282 317.646 118.541 315.258 119.205H315.254Z",
    fill: "#FFA400"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.76
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M315.839 103.503C314.669 101.572 313.102 103.979 314.758 105.279C316.41 106.579 316.419 104.455 315.839 103.503Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.76
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M310.421 121.687C309.793 120.194 307.415 121.164 308.632 122.516C309.845 123.867 310.732 122.426 310.421 121.687Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M306.957 90.4344L276.81 60.7502C276.81 60.7502 287.962 87.6746 306.957 90.4344Z",
    fill: "#FFF700"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M301.889 116.633L261.538 115.244C261.538 115.244 273.28 118.06 284.922 119.144C296.565 120.227 301.889 116.629 301.889 116.629V116.633Z",
    fill: "#FFF700"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M257.059 115.056L256.2 117.721L191.408 111.792L192.683 110.521C192.683 110.521 214.977 113.309 257.059 115.06V115.056Z",
    fill: "url(#paint24_linear_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M200.191 152.671H202.607L208.875 154.512L211.513 154.446L251.967 164.223L251.939 166.131L258.083 167.939L256.106 168.109L201.867 153.533L202.735 164.223L200.191 152.671Z",
    fill: "url(#paint25_linear_150_397)"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M243.01 164.591C243.01 164.591 209.3 154.493 200.191 152.671C200.191 152.671 205.774 158.958 243.01 164.591Z",
    fill: "#FFFFC4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M200.762 81.9525L198.327 82.2162L241.528 109.249V107.728L200.762 81.9525Z",
    fill: "#773960"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M257.597 115.395C257.597 115.395 227.2 116.049 192.178 111.029L192.687 110.521C222.759 114.392 287.145 116.276 308.93 116.822L310.369 116.921L257.597 115.395Z",
    fill: "#6FFFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.53,
    d: "M245.747 60.4111L243.463 68.926L240.027 70.4801L238.593 75.5334L240.471 77.9447L223.793 79.626L234.77 62.4598L245.747 60.4111Z",
    fill: "url(#paint26_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.53
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M215.586 115.979C215.586 115.979 222.646 114.137 228.592 116.996V124.103L230.107 125.454L216.596 123.778L215.581 115.979H215.586Z",
    fill: "#773960"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M241.528 62.0548L240.074 59.069L226.907 61.5462C226.907 61.5462 223.089 67.8287 222.075 77.163L224.047 80.2712L236.771 78.9384L241.533 62.0548H241.528Z",
    fill: "url(#paint27_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M238.206 59.4221C238.206 59.4221 236.176 62.6246 237.734 66.2933L234.491 75.4816L222.07 77.1629L224.043 80.2712L236.766 78.9384L239.81 68.1347L238.206 59.4221Z",
    fill: "#9F1F56"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M242.236 67.7015C242.236 67.7015 246.691 54.8774 248.343 48.7833C249.994 42.6892 247.96 42.5008 239.182 43.3862C230.404 44.2763 228.748 48.529 227.606 51.3218C226.459 54.1145 224.062 62.1819 223.811 64.24C223.566 66.2415 224.189 67.7015 224.189 67.7015C224.189 67.7015 225.506 64.0893 226.907 61.5461L231.49 60.6843C231.49 60.6843 233.604 52.9607 235.832 50.4835C238.059 48.0063 241.528 48.4678 241.528 48.4678C241.528 48.4678 238.248 58.5744 237.785 61.2259C237.021 65.6057 239.815 68.1348 239.815 68.1348L242.24 67.7015H242.236Z",
    fill: "url(#paint28_linear_150_397)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M226.969 116.996C226.969 116.996 220.418 115.282 215.581 115.979C215.581 115.979 215.199 123.024 216.279 127.531C216.279 127.531 220.48 131.341 226.52 129.754L226.964 116.996H226.969Z",
    fill: "url(#paint29_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M219.72 121.31C219.72 121.31 220.753 121.324 220.994 119.723C221.23 118.136 217.667 117.368 217.752 119.535C217.799 120.783 218.493 121.065 218.493 121.065C218.493 121.065 216.544 124.677 216.61 125.629C216.676 126.58 220.744 126.707 220.744 126.707L219.725 121.31H219.72Z",
    fill: "#720031"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M241.528 48.4678L241.986 46.5934C241.986 46.5934 236.45 45.8304 233.08 48.8775C229.711 51.9245 225.43 64.6167 225.43 64.6167L226.907 61.5461L231.49 60.6843C231.49 60.6843 233.557 52.8665 236.039 50.2621C236.978 49.2778 238.559 48.2935 241.528 48.4678Z",
    fill: "#9F1F56"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M248.258 43.8901C249.428 45.1994 241.839 58.2448 240.744 61.1976C239.645 64.1505 242.24 67.7062 242.24 67.7062C242.24 67.7062 247.46 52.485 248.569 49.0612C249.683 45.6374 248.258 43.8948 248.258 43.8948V43.8901Z",
    fill: "#9F1F56"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M236.766 78.9384L234.491 75.4769L222.075 77.1629L224.043 80.2712L236.766 78.9384Z",
    fill: "#9F1F56"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M226.969 116.996H223.089C223.089 116.996 222.707 126.632 223.089 130.131C223.089 130.131 225.506 130.263 226.525 129.754L226.969 116.996Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M217.667 125.84C217.606 124.889 219.55 121.277 219.55 121.277C219.55 121.277 218.856 120.99 218.809 119.746C218.776 118.837 219.385 118.447 220.088 118.414C220.654 118.673 221.074 119.144 220.985 119.723C220.744 121.324 219.71 121.31 219.71 121.31L220.73 126.707C220.73 126.707 219.715 126.674 218.686 126.523C218.111 126.363 217.681 126.147 217.657 125.84H217.667Z",
    fill: "#720031"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M236.039 59.8271L226.907 61.5461C226.907 61.5461 222.202 70.5602 222.075 77.1629C222.075 77.1629 224.543 68.4314 229.059 65.7046C233.576 62.9731 234.774 62.1819 234.774 62.1819L236.044 59.8319L236.039 59.8271Z",
    fill: "#FFFFC4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M223.028 68.1347C223.028 68.1347 212.24 69.1614 206.501 68.6716C200.762 68.1818 194.83 76.6449 194.83 76.6449C194.83 76.6449 195.293 73.8945 198.407 69.2603L223.486 64.5743L223.028 68.1395V68.1347Z",
    fill: "url(#paint30_linear_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M242.604 49.4379C241.655 50.4505 238.092 57.9528 237.889 60.7125C237.686 63.477 237.583 64.3907 237.889 65.0076C238.196 65.6246 240.343 62.4551 240.471 61.4001C240.598 60.3405 242.269 52.9654 242.934 50.6765C243.604 48.3924 243.397 48.5902 242.599 49.4379H242.604Z",
    fill: "url(#paint31_linear_150_397)"
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M237.068 45.1052C233.958 46.2355 227.261 54.9858 227.573 52.8194C227.884 50.653 228.531 47.5118 231.797 45.6656C235.062 43.8195 241.122 43.6311 237.068 45.1052Z",
    fill: "#FFFFC4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M227.356 55.9041C227.677 58.3672 226.412 63.1615 224.6 64.2588C222.787 65.3562 226.917 52.5039 227.356 55.9041Z",
    fill: "url(#paint32_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.76
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M325.244 73.3011C325.362 72.5476 324.168 72.8348 324.319 73.5648C324.47 74.2948 325.188 73.6731 325.244 73.3011Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.76
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M321.384 74.5915C321.502 73.838 320.308 74.1253 320.459 74.8552C320.61 75.5852 321.327 74.9635 321.384 74.5915Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M241.528 109.249L222.547 95.7279L241.528 107.728V109.249Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M226.969 116.996C226.969 116.996 221.532 115.348 215.581 115.979C215.581 115.979 215.189 120.552 215.737 124.041C215.737 124.041 217.171 117.345 218.252 116.996C219.333 116.648 223.085 116.996 223.085 116.996H226.964H226.969Z",
    fill: "url(#paint33_linear_150_397)"
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M202.924 111.585C197.709 113.695 195.019 113.431 193.825 113.662C192.635 113.893 192.862 119.144 192.862 119.144L191.408 111.792L192.683 110.521L202.924 111.585Z",
    fill: "#FFFFC4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M206.015 67.8381C203.816 68.4362 197.742 72.4346 196.789 75.6371C195.835 78.8442 195.76 80.4596 195.76 80.4596L193.83 80.681C193.83 80.681 194.783 73.8898 198.412 69.2557L206.02 67.8334L206.015 67.8381Z",
    fill: "#FFFFC4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M220.734 116.85C220.734 116.85 219.621 116.007 215.586 115.979C215.586 115.979 214.278 119.69 220.734 116.85Z",
    fill: "#FFFFC4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M226.969 116.996C226.969 116.996 225.331 128.078 223.089 130.131C223.089 130.131 225.954 131.873 227.526 130.446C229.097 129.02 226.969 116.996 226.969 116.996Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M234.77 51.0769C233.359 53.653 227.771 57.8539 229.366 54.788C230.961 51.7268 231.825 49.08 234.883 47.6625C237.941 46.2449 241.981 46.5934 241.981 46.5934L241.523 48.4678C241.523 48.4678 238.347 48.3501 237.139 49.3673C235.931 50.3846 234.765 51.0769 234.765 51.0769H234.77Z",
    fill: "#9F1F56"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M195.274 122.563L201.565 148.38C201.565 148.38 199.653 139.357 200.828 133.225C202.003 127.093 195.274 122.563 195.274 122.563Z",
    fill: "#FFFFC4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M251.061 131.958L251.826 159.118C251.826 159.118 251.693 152.007 253.468 145.211C255.247 138.42 251.061 131.958 251.061 131.958Z",
    fill: "url(#paint34_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.76
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M317.906 76.5271L319.109 76.8662L326.849 73.6401L326.892 74.1488L319.284 77.9305L317.911 76.8662L317.906 76.5271Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M326.892 74.1488L319.284 77.9306L317.911 76.8662L317.906 77.2571L319.199 78.2414L326.939 74.8128L326.892 74.1488Z",
    fill: "#FFF700"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M237.696 59.6953C237.696 59.6953 235.874 64.2824 229.961 68.9307C224.043 73.579 224.071 67.7674 225.265 65.0877C226.459 62.408 226.969 61.8334 226.969 61.8334L237.696 59.6953Z",
    fill: "url(#paint35_linear_150_397)"
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M252.802 60.7502C249.296 60.9386 250.169 59.8271 250.169 59.8271L246.781 60.218C246.781 60.218 246.917 61.9511 248.871 62.1442C250.825 62.3373 252.807 60.7502 252.807 60.7502H252.802Z",
    fill: "#60001B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M257.597 115.395C257.597 115.395 259.589 115.71 259.683 118.71C259.778 121.71 256.809 123.759 256.809 123.759C256.809 123.759 252.17 116.991 257.597 115.399V115.395Z",
    fill: "#FF7300"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M259.683 118.71C258.489 116.52 257.781 119.045 257.319 120.184C256.856 121.324 256.809 123.754 256.809 123.754C256.809 123.754 254.818 121.376 254.964 118.706C255.106 116.04 257.597 115.39 257.597 115.39C257.597 115.39 259.235 115.885 259.462 117.293L259.688 118.701L259.683 118.71Z",
    fill: "#60001B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M200.762 81.9525L193.83 80.6857L238.857 108.995L241.528 109.249V107.728L200.762 81.9525Z",
    fill: "#9F1F56"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_150_397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 80,
    width: 49,
    height: 30
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M200.762 81.9525L193.83 80.6857L238.857 108.995L241.528 109.249V107.728L200.762 81.9525Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_150_397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_150_397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 191,
    y: 47,
    width: 137,
    height: 133
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M256.583 179.906L300.369 172.818C300.142 171.725 300.095 170.605 300.888 170.638C301.577 170.666 302.318 170.953 302.922 171.259L306.042 162.763L303.37 162.255L311.002 130.64L313.673 130.508C313.673 130.508 314.565 127.842 315.405 123.25C317.915 121.918 320.138 119.761 321.115 116.784C322.465 112.682 321.318 108.203 319.298 105.001L320.289 103.654L319.355 102.726C321.667 98.8691 334.764 75.2744 320.289 57.4395C305.499 39.223 279.538 49.5369 272.223 55.9607L271.789 55.5321L254.766 58.7157C250.231 64.3436 246.771 60.2087 246.771 60.2087L198.407 69.2557C194.972 73.7015 193.825 80.681 193.825 80.681L203.08 86.5019C207.006 83.9258 207.558 88.56 207.62 89.3559L211.22 91.6212C212.962 90.2225 213.377 91.9038 213.472 93.034L238.852 108.995L241.523 109.249V107.728L200.762 81.9525L267.239 75.2368L310.369 111.024L314.315 111.787L315.027 110.817C315.641 111.886 315.966 113.021 315.65 114.26C315.287 115.696 314.272 116.45 312.998 116.916C302.058 116.662 265.974 115.729 233.708 113.883C233.708 113.883 229.371 117.312 228.257 115.39C227.743 114.505 227.431 113.897 227.243 113.497C224.496 113.327 221.792 113.148 219.154 112.96C218.776 113.695 217.856 114.99 216.879 112.795C207.69 112.126 199.347 111.368 192.688 110.511L191.413 111.783L193.197 120.797H194.849L202.612 152.661H200.196L202.74 164.214L256.588 179.896L256.583 179.906ZM251.967 164.223L217.761 155.958C216.945 156.792 215.694 157.644 214.213 157.272C212.783 156.914 212.499 155.727 212.547 154.696L211.508 154.446L205.911 122.45L250.948 128.035L251.963 164.218L251.967 164.223ZM311.823 95.2617L307.67 91.1408C306.863 91.6589 305.438 92.4124 304.508 92.0121C303.625 91.6306 303.885 89.2853 304.177 87.6746L301.464 84.9808C300.289 85.5318 298.571 86.144 297.849 85.4046C297.146 84.6841 297.58 82.8615 298.019 81.5616L285.862 69.5006C288.674 67.0704 304.428 54.2605 313.102 64.1741C322.946 75.4204 315.159 90.067 311.818 95.2569L311.823 95.2617ZM265.583 165.876L266.852 129.312L300.572 130.197L293.446 162.448L265.583 165.876Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_150_397)"
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M193.83 80.6856C193.83 80.6856 194.977 73.7014 198.412 69.2603L271.793 55.5415L320.29 103.663L314.31 111.787L310.365 111.024L267.235 75.2367L200.763 81.9525L241.528 107.728V109.249L238.857 108.995L193.83 80.6856Z",
    fill: "url(#paint36_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M310.369 111.029L267.239 75.2415L200.763 81.9526L241.528 107.728V109.249L238.857 108.995L193.83 80.6858L267.173 72.2416L309.251 106.711C309.251 106.711 304.956 100.329 310.587 99.472C316.217 98.6149 319.747 104.328 319.747 104.328C319.785 104.346 314.31 111.787 314.31 111.787L310.365 111.025L310.369 111.029Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.31
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M233.708 113.888L240.556 114.265C240.896 113.662 241.179 113.002 241.391 112.296C241.835 110.798 241.939 109.244 241.797 107.737L241.528 107.728L200.763 81.9525L267.239 75.2368L310.369 111.024L314.315 111.787L320.294 103.663L319.36 102.736C321.672 98.8786 334.768 75.2839 320.294 57.4489C317.982 54.5996 315.396 52.4521 312.654 50.8744C296.948 43.391 279.392 53.102 275.862 57.5761L272.388 55.8382C272.336 55.8806 272.28 55.9277 272.232 55.9701L271.798 55.5415C271.798 55.5415 267.754 62.5305 267.178 72.2415L193.83 80.6857L238.857 108.999C238.857 108.999 239.617 112.941 233.708 113.893V113.888ZM285.867 69.5053C288.679 67.0752 304.433 54.2653 313.107 64.1788C322.951 75.4251 315.164 90.0718 311.823 95.2617L285.867 69.5053Z",
    fill: "#C40040"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.53
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M193.193 120.806H194.844L203.721 122.454L208.875 154.512L211.513 154.446L205.916 122.45L250.953 128.035L258.683 129.307L258.084 167.934L256.106 168.104L256.583 179.901L302.479 172.474L306.042 162.763L303.371 162.255L311.002 130.64L313.673 130.508C313.673 130.508 314.565 127.842 315.405 123.25C317.916 121.918 320.138 119.761 321.115 116.784C323.98 108.086 315.627 97.7106 311.511 101.37C307.273 105.142 315.098 108.298 315.726 112.734L318.317 113.747C318.317 113.747 318.505 117.966 312.687 119.426C306.868 120.886 306.245 118.607 306.948 118.258C307.651 117.91 311.493 117.886 313.281 116.935L312.998 116.907C304.73 116.713 282.119 116.134 257.649 115.07C257.626 115.07 256.196 127.268 256.196 127.268L193.037 120.01L193.193 120.806ZM265.583 165.876L266.852 129.311L300.572 130.197L293.446 162.448L265.583 165.876Z",
    fill: "#773960"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M200.763 81.9525L198.327 82.2162L241.528 109.249V107.728L200.763 81.9525Z",
    fill: "#9F1F56"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M241.528 107.728L200.762 81.9525L267.239 75.2367L309.062 109.941L241.797 107.77C241.797 107.732 241.523 107.723 241.523 107.723L241.528 107.728Z",
    fill: "url(#paint37_linear_150_397)"
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M223.198 78.9384L223.576 79.5318L223.793 79.626L236.384 78.3544L237.139 77.6244L266.734 74.1488L310.369 111.029L267.239 75.2414L237.026 78.2932L236.766 78.9431L224.043 80.2759L223.595 79.6495L200.762 81.9572L220.933 94.7106L213.589 93.1141L207.94 89.5631C207.771 89.1157 207.601 88.6212 207.44 88.0749C206.695 85.5364 203.986 85.998 203.986 85.998L196.487 81.5946L223.198 78.9431V78.9384Z",
    fill: "#04A6FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M265.186 118.659C289.189 118.659 308.647 110.733 308.647 100.955C308.647 91.1783 289.189 83.2523 265.186 83.2523C241.184 83.2523 221.726 91.1783 221.726 100.955C221.726 110.733 241.184 118.659 265.186 118.659Z",
    fill: "url(#paint38_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M265.493 119.581C289.495 119.581 308.953 111.656 308.953 101.878C308.953 92.1012 289.495 84.1753 265.493 84.1753C241.49 84.1753 222.032 92.1012 222.032 101.878C222.032 111.656 241.49 119.581 265.493 119.581Z",
    fill: "url(#paint39_radial_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_150_397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 77,
    width: 98,
    height: 42
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M309.557 116.643V117.844C309.557 117.844 281.236 118.837 261.991 118.574C242.745 118.31 212.447 111.891 212.447 111.891V110.219C212.447 110.219 242.283 116.77 246.762 115.998C251.24 115.225 213.589 102.896 213.589 102.896L215.491 96.6037C215.491 96.6037 247.602 111.674 249.74 110.624C251.877 109.574 218.615 93.9005 218.615 93.9005L219.621 92.6148C219.621 92.6148 253.383 110.615 255.384 110.586C257.385 110.558 232.571 81.5144 232.571 81.5144L236.875 79.1691C236.875 79.1691 257.673 110.111 260.542 110.549C263.412 110.987 249.735 78.2743 249.735 78.2743L256.597 77.2052C256.597 77.2052 262.713 106.748 264.332 111.241C265.951 115.739 270.472 77.2052 270.472 77.2052L272.52 78.2743C272.52 78.2743 266.654 109.979 266.687 112.508C266.72 115.037 278.131 77.7185 278.131 77.7185L287.768 84.1423C287.768 84.1423 275.597 109.522 273.686 112.399C271.774 115.277 278.759 110.035 291.945 89.384L293.606 91.3196C293.606 91.3196 275.592 112.178 274.88 113.944C274.167 115.71 306.65 101.944 306.65 101.944L309.567 110.351C309.567 110.351 279.259 115.079 277.423 116.501C275.587 117.928 309.567 116.643 309.567 116.643H309.557Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_150_397)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.96,
    d: "M258.749 148.131C284.641 148.131 305.631 132.878 305.631 114.062C305.631 95.2464 284.641 79.9933 258.749 79.9933C232.856 79.9933 211.867 95.2464 211.867 114.062C211.867 132.878 232.856 148.131 258.749 148.131Z",
    fill: "url(#paint40_radial_150_397)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.58,
    d: "M285.791 112.206C265.568 113.026 249.263 115.861 249.372 118.541C249.475 121.22 265.955 122.727 286.173 121.908C306.396 121.089 322.701 118.253 322.592 115.574C322.489 112.894 306.009 111.387 285.791 112.206Z",
    fill: "url(#paint41_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.58,
    d: "M285.111 90.5803C271.128 105.976 261.373 119.925 263.317 121.743C265.266 123.556 278.178 112.55 292.162 97.1548C306.145 81.7593 315.9 67.8097 313.956 65.9918C312.011 64.174 299.095 75.1848 285.111 90.5803Z",
    fill: "url(#paint42_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.58,
    d: "M272.157 91.2208C264.398 106.225 260.009 119.398 262.35 120.641C264.695 121.885 272.883 110.728 280.642 95.7231C288.401 80.7186 292.79 67.546 290.449 66.3027C288.103 65.0594 279.915 76.2163 272.157 91.2208Z",
    fill: "url(#paint43_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.58,
    d: "M243.081 98.464C253.293 111.877 263.27 121.423 265.365 119.784C267.461 118.145 260.877 105.947 250.665 92.5347C240.452 79.122 230.475 69.5758 228.38 71.2147C226.284 72.8536 232.868 85.0513 243.081 98.464Z",
    fill: "url(#paint44_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.58,
    d: "M293.425 107.13C308.582 99.9765 319.941 92.2181 318.796 89.8009C317.65 87.3838 304.434 91.2232 289.276 98.3764C274.119 105.53 262.76 113.288 263.905 115.705C265.051 118.122 278.267 114.283 293.425 107.13Z",
    fill: "url(#paint45_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.58,
    d: "M285.739 107.751C271.477 111.67 260.476 116.939 261.165 119.525C261.859 122.111 273.983 121.037 288.245 117.118C302.507 113.2 313.508 107.93 312.818 105.345C312.125 102.759 300.001 103.833 285.739 107.751Z",
    fill: "url(#paint46_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.58,
    d: "M264.12 82.5788C262.996 96.2505 264.219 107.516 266.857 107.742C269.495 107.963 272.544 97.0606 273.667 83.3888C274.79 69.7171 273.568 58.4519 270.93 58.2258C268.291 58.0045 265.243 68.907 264.12 82.5788Z",
    fill: "url(#paint47_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.58,
    d: "M250.603 82.2727C254.511 96.8863 259.749 108.166 262.307 107.464C264.861 106.762 263.761 94.3479 259.853 79.7342C255.946 65.1206 250.707 53.8413 248.149 54.543C245.596 55.2447 246.696 67.659 250.603 82.2727Z",
    fill: "url(#paint48_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.58,
    d: "M236.153 107.309C249.716 116.304 261.887 121.776 263.336 119.534C264.785 117.293 254.964 108.18 241.396 99.1846C227.832 90.1894 215.661 84.717 214.212 86.9587C212.763 89.2004 222.584 98.3134 236.153 107.309Z",
    fill: "url(#paint49_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.58,
    d: "M265.704 118.073C266.12 115.426 253.788 111.299 238.161 108.854C222.533 106.409 209.528 106.572 209.112 109.219C208.696 111.866 221.027 115.993 236.655 118.438C252.283 120.883 265.288 120.72 265.704 118.073Z",
    fill: "url(#paint50_radial_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.91
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M290.109 87.1518C290.057 87.3355 290.166 87.5286 290.35 87.5757C290.534 87.6275 290.718 87.5192 290.77 87.3308C290.822 87.1424 290.713 86.954 290.529 86.9069C290.345 86.8598 290.161 86.9634 290.109 87.1518Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M286.281 86.0969C285.654 88.4187 287.008 90.8205 289.302 91.4516C291.595 92.0874 293.965 90.7169 294.587 88.3904C295.215 86.0686 293.861 83.6668 291.567 83.0357C289.273 82.3999 286.904 83.7704 286.281 86.0969Z",
    fill: "url(#paint51_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.54
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M272.275 94.2726C272.26 94.3197 272.289 94.3715 272.336 94.381C272.383 94.3951 272.43 94.3668 272.445 94.3197C272.459 94.2726 272.43 94.2208 272.383 94.2114C272.336 94.1973 272.289 94.2255 272.275 94.2726Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M268.905 93.3401C268.386 95.2758 269.509 97.2726 271.42 97.8001C273.332 98.3275 275.3 97.1878 275.824 95.2522C276.343 93.3166 275.219 91.3198 273.308 90.7923C271.397 90.2648 269.429 91.4045 268.905 93.3401Z",
    fill: "url(#paint52_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M243.552 65.0032C243.543 65.0364 243.562 65.0744 243.6 65.0839C243.633 65.0933 243.671 65.0744 243.681 65.0364C243.69 65.0032 243.671 64.9653 243.633 64.9558C243.6 64.9463 243.562 64.9653 243.552 65.0032Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M242.944 64.8334C242.845 65.2101 243.062 65.5963 243.43 65.6999C243.798 65.8035 244.18 65.5822 244.284 65.2054C244.388 64.8287 244.166 64.4425 243.798 64.3389C243.43 64.2353 243.047 64.4566 242.944 64.8334Z",
    fill: "url(#paint53_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M232.099 85.7907C232.198 86.37 232.736 86.7562 233.307 86.6573C233.878 86.5584 234.26 86.0073 234.161 85.4328C234.062 84.8535 233.524 84.4673 232.953 84.5662C232.382 84.6651 232 85.2161 232.099 85.7907Z",
    fill: "url(#paint54_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.92
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M303.875 95.9774C303.889 96.0716 303.979 96.1328 304.073 96.1187C304.168 96.1046 304.229 96.0151 304.21 95.9209C304.196 95.8267 304.106 95.7655 304.012 95.7796C303.918 95.7937 303.856 95.8832 303.875 95.9774Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M296.489 97.2631C297.207 101.488 301.171 104.327 305.343 103.602C309.515 102.877 312.313 98.8596 311.596 94.6352C310.879 90.4107 306.914 87.5709 302.742 88.2962C298.571 89.0214 295.772 93.0387 296.489 97.2631Z",
    fill: "url(#paint55_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M277.093 71.1207C277.083 71.1583 277.107 71.2007 277.145 71.2101C277.183 71.2196 277.22 71.196 277.234 71.1583C277.244 71.1207 277.22 71.0783 277.183 71.0688C277.145 71.0594 277.107 71.083 277.093 71.1207Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M275.587 70.7062C275.351 71.5869 275.861 72.4958 276.73 72.736C277.598 72.9762 278.495 72.4581 278.731 71.5774C278.966 70.6968 278.457 69.7878 277.588 69.5476C276.72 69.3074 275.823 69.8255 275.587 70.7062Z",
    fill: "url(#paint56_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M239.13 89.0592C239.168 89.2758 239.371 89.4218 239.584 89.3841C239.796 89.3465 239.942 89.144 239.904 88.9273C239.867 88.7107 239.664 88.5647 239.451 88.6024C239.239 88.64 239.093 88.8425 239.13 89.0592Z",
    fill: "url(#paint57_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.73
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M285.442 89.6244C285.442 89.6244 285.442 89.6483 285.456 89.653C285.47 89.6578 285.48 89.653 285.485 89.6387C285.489 89.6244 285.485 89.6149 285.47 89.6101C285.461 89.6101 285.446 89.6101 285.442 89.6244Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M285.262 89.5772C285.234 89.6855 285.295 89.8032 285.404 89.8315C285.512 89.8597 285.626 89.7985 285.654 89.6855C285.682 89.5772 285.621 89.4594 285.512 89.4312C285.404 89.4029 285.291 89.4641 285.262 89.5772Z",
    fill: "url(#paint58_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.68
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M226.573 93.8304C226.577 93.8588 226.606 93.8826 226.634 93.8731C226.663 93.8683 226.682 93.8399 226.677 93.8114C226.672 93.783 226.644 93.7592 226.615 93.7687C226.587 93.7782 226.568 93.8019 226.573 93.8304Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M224.793 94.136C224.968 95.1627 225.926 95.8503 226.941 95.6713C227.95 95.4971 228.63 94.5222 228.455 93.4955C228.281 92.4688 227.323 91.7813 226.308 91.9602C225.298 92.1345 224.619 93.1093 224.793 94.136Z",
    fill: "url(#paint59_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.55
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M274.124 101.327C274.115 101.37 274.139 101.412 274.176 101.422C274.219 101.431 274.261 101.407 274.271 101.365C274.28 101.323 274.257 101.28 274.219 101.271C274.176 101.261 274.134 101.285 274.124 101.327Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M272.44 100.866C272.175 101.85 272.746 102.863 273.714 103.131C274.681 103.4 275.682 102.82 275.946 101.836C276.21 100.852 275.639 99.8392 274.672 99.5708C273.704 99.3023 272.704 99.8816 272.44 100.866Z",
    fill: "url(#paint60_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.74
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M308.401 94.8569C308.401 94.8569 308.425 94.8949 308.449 94.8901C308.472 94.8901 308.487 94.8664 308.482 94.8427C308.482 94.819 308.458 94.8048 308.434 94.8095C308.411 94.8095 308.396 94.8332 308.401 94.8569Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M307.707 94.979C307.778 95.3887 308.16 95.6619 308.566 95.5912C308.972 95.5206 309.241 95.1344 309.17 94.7247C309.1 94.315 308.717 94.0418 308.311 94.1124C307.906 94.1831 307.637 94.5693 307.707 94.979Z",
    fill: "url(#paint61_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M280.085 91.0419C280.076 91.0796 280.099 91.1173 280.132 91.1314C280.17 91.1408 280.208 91.1173 280.217 91.0796C280.227 91.0419 280.203 91.0042 280.17 90.9901C280.132 90.9807 280.095 91.0042 280.085 91.0419Z",
    fill: "url(#paint62_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.73
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M259.98 73.777C259.971 73.8054 259.99 73.8386 260.019 73.8434C260.047 73.8529 260.076 73.8339 260.085 73.8054C260.095 73.777 260.076 73.7438 260.047 73.739C260.019 73.7296 259.99 73.7485 259.98 73.777Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M256.625 72.849C256.111 74.7563 257.22 76.7249 259.103 77.243C260.986 77.761 262.925 76.6401 263.44 74.7328C263.954 72.8254 262.845 70.8569 260.962 70.3388C259.079 69.8208 257.14 70.9416 256.625 72.849Z",
    fill: "url(#paint63_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.76
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M268.013 71.2574C268.013 71.2574 268.013 71.2812 268.027 71.286C268.042 71.2907 268.051 71.286 268.056 71.2717C268.056 71.2621 268.056 71.2478 268.042 71.243C268.032 71.243 268.018 71.243 268.013 71.2574Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M267.447 71.1018C267.357 71.4314 267.55 71.7705 267.871 71.86C268.197 71.9495 268.527 71.7564 268.617 71.4267C268.707 71.097 268.513 70.758 268.192 70.6685C267.867 70.579 267.536 70.7721 267.447 71.1018Z",
    fill: "url(#paint64_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M254.841 98.5112C254.799 98.5913 254.827 98.6855 254.907 98.7278C254.983 98.7702 255.082 98.742 255.124 98.6619C255.167 98.5819 255.139 98.4877 255.058 98.4453C254.983 98.4029 254.884 98.4311 254.841 98.5112Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M252.151 97.0513C251.311 98.6337 251.901 100.607 253.463 101.459C255.025 102.307 256.974 101.714 257.814 100.131C258.654 98.5489 258.065 96.5756 256.502 95.7232C254.94 94.8755 252.991 95.4689 252.151 97.0513Z",
    fill: "url(#paint65_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.99
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M216.987 100.89C216.954 100.946 216.978 101.021 217.034 101.054C217.091 101.087 217.167 101.064 217.195 101.007C217.228 100.951 217.204 100.875 217.148 100.842C217.091 100.809 217.016 100.833 216.987 100.89Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M213.962 99.2459C213.032 100.998 213.684 103.178 215.411 104.12C217.138 105.062 219.295 104.403 220.22 102.651C221.15 100.899 220.499 98.7184 218.771 97.7765C217.044 96.8346 214.887 97.494 213.962 99.2459Z",
    fill: "url(#paint66_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.67
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M240.98 86.747C240.98 86.747 240.98 86.7758 240.99 86.7854C241.005 86.7902 241.019 86.7854 241.029 86.7758C241.033 86.7614 241.029 86.747 241.019 86.7374C241.005 86.7326 240.99 86.7374 240.98 86.747Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M239.697 86.045C239.31 86.775 239.579 87.6886 240.301 88.0795C241.023 88.4704 241.924 88.1973 242.311 87.4673C242.698 86.7373 242.429 85.8237 241.707 85.4328C240.985 85.0419 240.084 85.315 239.697 86.045Z",
    fill: "url(#paint67_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M249.07 99.4954C248.914 99.7921 249.022 100.164 249.315 100.324C249.608 100.484 249.976 100.371 250.136 100.075C250.292 99.778 250.183 99.4059 249.891 99.2458C249.598 99.0857 249.23 99.1987 249.07 99.4954Z",
    fill: "url(#paint68_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.92
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M225.369 99.5427C225.369 99.5427 225.369 99.5854 225.383 99.5949C225.402 99.6044 225.426 99.5949 225.435 99.5807C225.445 99.5664 225.435 99.538 225.421 99.5285C225.402 99.519 225.378 99.5285 225.369 99.5427Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M222.896 98.1956C222.15 99.599 222.674 101.351 224.057 102.105C225.444 102.858 227.167 102.331 227.913 100.927C228.658 99.5237 228.134 97.7717 226.752 97.0182C225.364 96.2647 223.642 96.7922 222.896 98.1956Z",
    fill: "url(#paint69_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.72
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M230.183 80.8414C230.164 80.8746 230.178 80.9173 230.211 80.9315C230.244 80.9505 230.282 80.9363 230.301 80.9031C230.32 80.8699 230.306 80.8272 230.273 80.8129C230.24 80.794 230.202 80.8082 230.183 80.8414Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M227.677 79.48C226.917 80.9117 227.45 82.6966 228.861 83.4643C230.277 84.2319 232.037 83.6951 232.797 82.2634C233.557 80.8317 233.024 79.0468 231.612 78.2791C230.197 77.5115 228.436 78.0483 227.677 79.48Z",
    fill: "url(#paint70_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M305.461 100.767C305.574 101.436 306.202 101.888 306.863 101.77C307.523 101.657 307.967 101.017 307.854 100.348C307.74 99.6791 307.113 99.227 306.452 99.3447C305.791 99.4577 305.348 100.098 305.461 100.767Z",
    fill: "url(#paint71_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M256.031 74.1916C256.031 74.1916 256.031 74.2204 256.05 74.2252C256.064 74.2252 256.079 74.2252 256.083 74.206C256.088 74.1868 256.083 74.1772 256.064 74.1724C256.05 74.1724 256.035 74.1724 256.031 74.1916Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M255.516 74.0499C255.436 74.3513 255.61 74.6622 255.908 74.7469C256.205 74.8317 256.512 74.6527 256.592 74.3513C256.672 74.0499 256.498 73.7391 256.2 73.6543C255.903 73.5743 255.596 73.7485 255.516 74.0499Z",
    fill: "url(#paint72_radial_150_397)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M263.775 115.79C290.389 115.79 311.964 108.128 311.964 98.6759C311.964 89.2239 290.389 81.5615 263.775 81.5615C237.161 81.5615 215.586 89.2239 215.586 98.6759C215.586 108.128 237.161 115.79 263.775 115.79Z",
    fill: "url(#paint73_radial_150_397)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_150_397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 75,
    width: 129,
    height: 42
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M314.036 111.736L310.364 111.024L267.234 75.2367L236.955 78.2649L236.766 78.9337L224.043 80.2665L223.642 79.6354L198.327 82.2068L193.825 80.6762L186 96.7686C186 96.7686 188.898 109.951 192.683 110.52C200.215 111.655 216.874 112.805 216.874 112.805C216.874 112.805 217.544 113.878 219.149 112.969L227.238 113.506C227.238 113.506 228.62 115.701 233.703 113.892L257.055 115.06L257.626 115.084C286.598 116.384 312.988 116.921 312.988 116.921L314.031 111.74L314.036 111.736Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_150_397)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M274.771 161.798C301.023 161.798 322.304 140.729 322.304 114.74C322.304 88.751 301.023 67.6826 274.771 67.6826C248.519 67.6826 227.238 88.751 227.238 114.74C227.238 140.729 248.519 161.798 274.771 161.798Z",
    fill: "url(#paint74_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M264.2 157.569C288.976 157.569 309.062 136.5 309.062 110.511C309.062 84.5219 288.976 63.4535 264.2 63.4535C239.423 63.4535 219.337 84.5219 219.337 110.511C219.337 136.5 239.423 157.569 264.2 157.569Z",
    fill: "url(#paint75_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M310.088 108.221C310.339 84.6521 292.225 65.3511 269.629 65.1111C247.032 64.871 228.51 83.7827 228.259 107.352C228.007 130.921 246.121 150.222 268.718 150.462C291.314 150.702 309.836 131.79 310.088 108.221Z",
    fill: "url(#paint76_radial_150_397)"
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M285.833 118.546C287.815 119.139 296.013 114.938 296.773 112.447C297.414 110.342 295.451 106.155 295.107 105.863C294.762 105.575 286.182 102.166 284.205 102.453C282.223 102.745 279.122 105.835 278.797 107.615C278.471 109.39 283.658 117.891 285.838 118.546H285.833Z",
    fill: "url(#paint77_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M284.035 103.404C277.404 105.434 283.431 116.859 288.254 115.456C288.282 115.447 288.311 115.437 288.334 115.428C301.752 110.196 291.426 103.852 284.309 103.371C284.219 103.367 284.125 103.371 284.035 103.404Z",
    fill: "#6EF3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M286.22 117.957C286.112 117.962 287.343 114.269 288.33 112.871C289.311 111.472 294.295 110.111 294.838 110.158C295.38 110.205 296.612 112.004 296.612 112.004C296.612 112.004 292.95 117.561 286.22 117.957Z",
    fill: "#368ADD"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M279.075 107.2C279.075 107.2 281.888 103.569 284.601 102.712C284.601 102.712 291.487 104.982 294.852 109.579C294.852 109.579 289.533 111.915 287.117 112.202C287.117 112.202 282.043 109.517 279.075 107.205V107.2Z",
    fill: "url(#paint78_linear_150_397)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M285.706 103.056C287.315 103.899 290.76 105.637 293.913 109.287C294.356 109.8 289.321 112.056 287.716 111.721C286.111 111.387 279.075 107.2 279.075 107.2C279.075 107.2 279.33 112.263 285.319 118.089C285.319 118.089 287.617 113.332 288.278 112.56C288.938 111.787 294.342 109.866 294.856 109.805C295.371 109.739 296.716 111.66 296.716 111.66C296.716 111.66 296.414 107.902 295.022 106.258C293.629 104.615 285.706 103.056 285.706 103.056Z",
    fill: "#6DBBFF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M279.339 107.511C279.339 107.511 284.082 110.987 287.183 112.343C287.183 112.343 287.476 112.682 285.423 112.028C283.37 111.378 279.339 107.511 279.339 107.511Z",
    fill: "#6EFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M284.601 102.712C284.601 102.712 290.661 105.364 294.852 109.579C294.852 109.579 291.232 105.354 289.028 104.389C286.824 103.423 284.601 102.717 284.601 102.717V102.712Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M279.075 107.2C279.075 107.2 281.888 103.569 284.601 102.712C284.601 102.712 291.487 104.982 294.852 109.579C294.852 109.579 290.873 107.879 286.588 107.238C282.185 106.579 280.689 108.043 279.075 107.205V107.2Z",
    fill: "url(#paint79_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.55
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M279.528 108.627C280.463 109.536 281.524 111.006 282.162 111.924C282.799 112.842 282.6 115.018 282.317 114.651C280.458 112.225 278.858 107.968 279.528 108.627Z",
    fill: "#0978FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M294.62 105.919C294.781 106.192 293.379 105.872 292.723 105.656C291.704 105.321 291.156 104.464 291.808 104.709C292.903 105.123 294.455 105.632 294.62 105.919Z",
    fill: "#6EF6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M286.895 116.605C288.273 115.974 293.724 114.66 295.083 113.45C296.442 112.24 294.05 115.423 291.902 116.44C289.755 117.458 286.635 118.126 286.319 118.131C286.003 118.136 286.895 116.605 286.895 116.605Z",
    fill: "#368ADD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M288.419 112.428C288.419 112.428 293.214 110.13 294.847 109.574C294.847 109.574 294.734 112.418 288.419 112.428Z",
    fill: "#6EFFFF"
  }))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M284.951 111.844C284.951 111.844 285.088 111.387 285.937 111.74C286.277 111.882 286.744 112.056 287.164 112.037C287.73 112.009 288.599 111.849 289.259 111.693C290 111.519 287.466 113.078 287.358 113.064C286.687 112.969 284.955 111.844 284.955 111.844H284.951Z",
    fill: "#DBFFFF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M294.918 109.682C294.956 109.823 293.95 110.125 293.917 110.045C293.889 109.965 294.224 109.418 294.484 109.235C294.691 109.084 294.918 109.682 294.918 109.682Z",
    fill: "#DBFFFF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M291.392 110.958C291.26 110.276 289.708 110.765 289.807 111.561C289.901 112.357 291.525 111.623 291.392 110.958Z",
    fill: "url(#paint80_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M291.393 110.959C291.26 110.276 289.75 110.728 289.845 111.524C289.939 112.32 291.52 111.623 291.393 110.959Z",
    fill: "#368AA7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M289.807 111.561C289.713 110.766 291.261 110.28 291.393 110.959C291.393 110.973 291.393 110.987 291.397 111.001C291.412 111.147 291.322 111.293 291.194 111.382C290.85 111.618 290.288 111.679 290.137 111.472C289.967 111.232 289.746 111.444 289.84 111.698C289.821 111.66 289.807 111.613 289.802 111.561H289.807Z",
    fill: "#368AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M289.807 111.561C289.84 111.825 290.033 111.919 290.274 111.905C289.925 111.948 289.637 111.863 289.595 111.58C289.533 111.156 290.057 110.813 290.586 110.685C290.166 110.803 289.755 111.138 289.807 111.561Z",
    fill: "#6EF6FF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.67,
    d: "M291.393 110.959C291.345 110.709 291.105 110.619 290.831 110.638C291.208 110.596 291.544 110.676 291.61 110.94C291.695 111.288 291.152 111.674 290.609 111.834C291.039 111.679 291.463 111.307 291.397 110.959H291.393Z",
    fill: "url(#paint81_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M291.393 110.959C291.445 111.218 291.227 111.486 290.94 111.67C291.161 111.51 291.294 111.142 290.921 111.095C290.51 111.043 290.18 110.926 290.435 110.737C290.845 110.568 291.322 110.596 291.393 110.959Z",
    fill: "#368AFF"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M289.859 111.905C289.915 111.877 289.778 111.745 289.665 111.665C289.552 111.585 289.665 111.999 289.859 111.905Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M294.899 106.127C294.295 106.216 292.945 106.131 292.152 105.759C291.36 105.382 286.216 103.108 286.447 103.15C291.827 104.12 295.324 106.065 294.899 106.127Z",
    fill: "#6EF6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M280.755 111.401C281.279 111.58 282.685 113.761 283.129 114.387C283.573 115.013 285.512 117.99 285.371 117.839C281.864 114.147 280.392 111.274 280.755 111.401Z",
    fill: "#6EF6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M324.329 136.041C324.329 136.041 318.755 138.702 318.18 138.989C317.604 139.277 314.768 133.762 314.447 133.173C314.126 132.585 312.988 131.068 312.597 130.753C312.351 130.555 312.413 123.971 312.488 119.111C312.535 116.195 311.063 120.481 308.16 120.175L306.268 116.473L304.512 118.814L302.403 116.916C302.403 116.916 300.024 110.516 299.382 111.938C298.741 113.356 297.079 117.721 296.744 118.018C296.409 118.315 296.947 111.698 296.669 111.396C296.386 111.095 291.378 113.789 291.124 110.765C291.039 109.776 290.51 105.792 289.967 105.754C289.425 105.717 283.62 107.902 283.62 107.902C283.62 107.902 282.407 103.23 279.943 99.7356L279.981 98.9962C279.981 98.9962 277.456 105.048 276.805 105.74C276.154 106.433 278.83 108.17 277.721 108.312C276.612 108.453 275.12 107.092 274.469 106.513C273.818 105.933 270.76 105.335 270.76 105.335L269.042 109.381L247.616 133.531C247.616 133.531 248.442 138.26 248.508 138.636C248.574 139.013 247.007 139.493 247.007 139.493L243.18 141.914L253.251 150.848L301.818 154.733C301.818 154.733 318.316 151.498 318.633 151.013C318.949 150.528 324.329 136.032 324.329 136.032V136.041Z",
    fill: "#003E8B"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M287.527 119.134C287.15 118.423 287.31 117.571 287.943 116.949C292.185 112.805 297.466 110.445 298.509 110.389C299.378 110.342 306.339 114.001 307.179 115.871C307.783 117.213 305.555 124.512 303.771 125.907C302.28 127.074 295.036 128.469 293.823 127.988C291.982 127.263 288.835 121.611 287.523 119.13L287.527 119.134Z",
    fill: "url(#paint82_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M301.261 112.965C297.013 110.629 291.831 113.845 288.901 117.552C288.707 117.797 288.674 118.098 288.811 118.352C291.067 122.563 292.672 126.519 298.221 125.624C300.463 125.224 302.172 124.621 302.36 124.432C304.734 122.078 306.391 114.844 301.365 113.017C301.327 113.002 301.294 112.988 301.261 112.969V112.965Z",
    fill: "#6EF3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M303.719 125.553C303.719 125.553 301.284 121.725 300.883 119.506C300.487 117.302 302.247 115.329 302.247 115.329C302.247 115.329 306.15 115.418 306.943 115.974C307.721 116.52 305.966 123.086 303.719 125.549V125.553Z",
    fill: "#368ADD"
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M287.844 118.494C287.844 118.494 293.568 120.444 299.859 118.503C299.859 118.503 301.478 116.365 301.945 115.414C302.403 114.481 298.486 110.761 298.486 110.761C298.486 110.761 291.223 112.701 287.844 118.494Z",
    fill: "url(#paint83_linear_150_397)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M287.844 118.494C287.844 118.494 289.953 115.758 296.574 114.057C300.633 113.017 301.478 116.365 301.945 115.414C302.403 114.481 298.486 110.761 298.486 110.761C298.486 110.761 291.223 112.701 287.844 118.494Z",
    fill: "url(#paint84_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M302.823 112.564C301.308 111.627 305.05 115.141 305.352 115.659C305.654 116.177 305.904 121.206 305.621 122.097C305.333 122.996 306.957 119.445 307.084 117.439C307.207 115.466 307.132 115.225 302.823 112.569V112.564Z",
    fill: "#368AC5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M298.481 110.756C298.481 110.756 301.308 114.453 301.624 114.933C301.808 115.211 301.747 115.48 301.662 115.654L299.854 118.498C302.884 117.448 302.242 115.334 302.242 115.334C302.242 115.334 301.053 112.122 298.481 110.761V110.756Z",
    fill: "#6EFFFF"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M296.673 111.397C296.673 111.397 296.513 111.585 297.254 111.439C298.023 111.283 298.254 110.836 298.254 110.836C298.254 110.836 297.362 110.827 296.678 111.397H296.673Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M297.631 111.034C295.107 111.858 290.283 114.905 288.537 117.801C288.16 118.423 293.535 116.134 293.913 115.998C295.121 115.55 298.542 110.732 297.627 111.034H297.631Z",
    fill: "url(#paint85_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M290.704 122.181C290.788 120.702 295.48 119.657 294.753 119.403C294.017 119.144 291.529 119.148 290.345 118.607C289.137 118.056 289.075 117.133 289.321 116.652C289.561 116.177 287.669 117.806 287.693 118.649C287.721 119.497 290 123.453 290.633 124.112C291.26 124.767 290.633 123.377 290.704 122.181Z",
    fill: "#6EFFFF"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M200.771 108.83C200.72 108.18 201.107 107.596 201.777 107.337C206.251 105.594 210.932 105.514 211.725 105.802C212.386 106.042 216.402 110.968 216.435 112.626C216.459 113.817 212.475 118.546 210.71 119.017C209.229 119.412 203.395 118.159 202.645 117.42C201.503 116.299 200.96 111.095 200.776 108.835L200.771 108.83Z",
    fill: "url(#paint86_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M212.952 108.585C210.536 105.505 205.656 106.254 202.296 108.086C202.074 108.208 201.956 108.42 201.975 108.651C202.315 112.498 202.253 115.951 206.666 117.038C208.464 117.448 209.927 117.542 210.125 117.462C212.641 116.464 216.171 111.604 213.013 108.651C212.99 108.632 212.971 108.608 212.952 108.58V108.585Z",
    fill: "#6EF3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M210.781 118.734C210.781 118.734 210.187 115.112 210.592 113.337C210.998 111.571 212.933 110.662 212.933 110.662C212.933 110.662 215.812 111.966 216.223 112.63C216.628 113.285 213.235 117.613 210.781 118.734Z",
    fill: "#368ADD"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M201.21 108.453C201.21 108.453 204.854 111.717 210.149 112.263C210.149 112.263 212.032 111.185 212.683 110.624C213.32 110.073 211.588 106.065 211.588 106.065C211.588 106.065 205.566 105.208 201.21 108.453Z",
    fill: "url(#paint87_linear_150_397)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M201.05 108.524C201.05 108.524 204.646 111.364 210.007 112.447C210.654 112.579 210.588 119.045 210.588 119.045C210.588 119.045 204.113 118.753 202.626 117.024C201.201 115.371 201.05 108.524 201.05 108.524Z",
    fill: "#6DBBFF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M201.234 108.825C201.234 108.825 205.316 111.585 210.163 112.588C210.163 112.588 206.35 111.801 204.311 111.269C202.154 110.704 201.069 108.9 201.069 108.9L201.229 108.83L201.234 108.825Z",
    fill: "#6EFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M201.21 108.453C201.21 108.453 203.65 107.083 209.12 107.916C212.471 108.425 212.037 111.185 212.683 110.624C213.32 110.073 211.588 106.065 211.588 106.065C211.588 106.065 205.566 105.208 201.21 108.453Z",
    fill: "url(#paint88_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M202.003 114.707C202.173 116.021 202.216 116.888 203.277 117.458C204.306 118.013 204.731 118.004 205.283 118.023C205.826 118.042 201.895 113.874 202.003 114.707Z",
    fill: "#6EF6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M214.24 108.783C213.41 107.605 215.081 111.401 215.137 111.886C215.198 112.367 213.783 116.191 213.292 116.761C212.792 117.335 215.132 115.211 215.859 113.756C216.577 112.329 216.595 112.122 214.236 108.783H214.24Z",
    fill: "#368AC5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M211.588 106.065C211.588 106.065 212.518 109.71 212.598 110.167C212.645 110.436 212.513 110.615 212.4 110.718L210.149 112.263C212.735 112.442 212.933 110.662 212.933 110.662C212.933 110.662 213.07 107.897 211.588 106.065Z",
    fill: "#6EFFFF"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M210.036 105.966C210.036 105.966 209.856 106.056 210.456 106.183C211.079 106.315 211.39 106.051 211.39 106.051C211.39 106.051 210.729 105.764 210.036 105.971V105.966Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M210.588 118.668C210.687 118.075 210.12 115.564 210.153 115.004C210.187 114.439 210.238 112.838 210.238 112.838L210.536 112.734C210.536 112.734 210.602 115.612 210.673 116.652C210.743 117.688 210.588 118.668 210.588 118.668Z",
    fill: "#6EFFFF"
  }))), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M209.672 112.588C209.531 112.338 210.526 111.801 210.611 111.938C210.696 112.075 210.592 113.087 210.375 113.45C210.201 113.746 209.672 112.583 209.672 112.583V112.588Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M210.866 106.004C208.728 105.82 204.169 106.56 201.947 108.161C201.47 108.505 206.194 108.505 206.52 108.519C207.563 108.571 211.635 106.065 210.861 105.999L210.866 106.004Z",
    fill: "url(#paint89_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M206.624 118.268C208.511 117.834 210.465 117.797 210.692 117.034C210.913 116.271 211.4 117.764 212.485 117.307C213.537 116.864 211.579 118.659 210.649 118.875C209.696 119.097 205.585 118.508 206.624 118.268Z",
    fill: "#368AC5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M202.168 112.103C202.702 111.029 206.524 111.736 206.067 111.316C205.599 110.888 203.749 110.106 203.037 109.329C202.31 108.538 202.56 107.831 202.895 107.549C203.226 107.271 201.295 107.883 201.05 108.519C200.8 109.159 201.239 112.823 201.503 113.516C201.763 114.199 201.739 112.969 202.168 112.103Z",
    fill: "#6EFFFF"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M281.765 109.673C284.115 106.79 280.552 97.3337 277.99 94.2773C275.941 91.8377 264.643 88.8801 262.888 88.753C261.982 88.6871 257.621 90.7734 255.332 91.9037C254.572 92.2804 254.303 93.2223 254.752 93.9429C256.753 97.1501 261.831 105.123 263.515 106.287C266.984 108.684 280.246 111.533 281.765 109.673Z",
    fill: "url(#paint90_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M260.854 90.811C260.924 90.7875 260.991 90.7592 261.057 90.7262C263.605 89.4876 276.008 94.6869 275.611 95.1061C277.791 97.3149 284.908 107.732 277.239 107.092C277.211 107.092 274.46 107.195 274.431 107.191C271.194 106.706 265.719 105.137 264.148 104.092C264.068 104.035 263.992 103.974 263.931 103.899C263.01 102.839 253.784 93.0009 260.858 90.811H260.854Z",
    fill: "#6EF3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M270.236 100.315C270.236 100.315 262.203 95.3228 255.058 93.3824C255.058 93.3824 261.057 103.282 263.275 105.472C265.493 107.662 274.441 109.329 274.441 109.329C274.441 109.329 272.482 102.933 270.24 100.315H270.236Z",
    fill: "#368ADD"
  }))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.046 93.8534C275.606 95.1061 270.387 99.5566 270.387 99.5566C270.387 99.5566 258.414 94.1736 255.719 92.6006C255.719 92.6006 260.339 89.7184 263.27 89.2569C266.201 88.8 277.046 93.8534 277.046 93.8534Z",
    fill: "url(#paint91_linear_150_397)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M277.234 93.8864C276.012 94.7058 270.387 99.5519 270.387 99.5519C270.387 99.5519 274.611 108.443 275.281 109.418C275.951 110.393 281.09 109.932 281.737 109.126C282.383 108.321 282.025 102.09 280.316 98.8031C278.613 95.5158 277.234 93.8864 277.234 93.8864Z",
    fill: "#6DBBFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M274.148 92.8927C268.546 90.3825 264.912 89.4171 263.473 89.4877C262.033 89.5537 255.922 92.2098 256.587 92.6007C257.253 92.9916 268.183 91.8613 270.07 92.078C271.958 92.2946 274.148 92.8927 274.148 92.8927Z",
    fill: "url(#paint92_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M280.944 100.31C283.228 105.293 282.062 108.557 281.836 109.15C281.609 109.748 279.641 110.473 279.212 110.196C278.985 110.05 281.038 108.095 281.458 105.364C281.845 102.867 280.581 99.5284 280.939 100.31H280.944Z",
    fill: "#368AC5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M262.723 96.5001C258.541 95.1485 258.4 97.3808 259.513 99.307C260.627 101.233 262.85 104.332 263.397 105.161C263.94 105.995 262.524 105.133 258.187 98.8125C253.855 92.497 254.256 92.709 255.511 93.1799C256.767 93.6556 262.723 96.4954 262.723 96.4954V96.5001Z",
    fill: "#368ADD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M267.753 98.3416C268.268 98.6665 270.099 99.0857 270.514 98.7466C274.026 95.8926 277.046 93.8534 277.046 93.8534C277.046 93.8534 274.087 97.0135 272.331 98.5818C271.878 98.9868 271.491 99.2317 271.17 99.3682C271.137 99.3871 271.1 99.4059 271.057 99.4153C270.967 99.4483 270.887 99.4719 270.812 99.4907C270.543 99.5943 270.439 99.7167 270.439 99.7167C270.439 99.7167 265.068 99.081 262.614 97.5975C260.16 96.114 255.724 92.5959 255.724 92.5959C255.724 92.5959 261.43 94.3809 267.758 98.3416H267.753Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M270.434 99.7168C270.434 99.7168 271.746 100.96 272.142 102.119C272.539 103.277 273.936 106.866 273.936 106.866C273.936 106.866 271.76 104.935 271.222 103.164C270.684 101.393 270.269 99.6932 270.269 99.6932L270.439 99.7168H270.434Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M262.572 95.9728C264.266 96.764 267.848 97.9602 270.127 97.541C272.411 97.1266 277.046 93.8488 277.046 93.8488C275.606 95.1015 270.387 99.552 270.387 99.552C270.387 99.552 266.441 97.7812 262.572 95.9728Z",
    fill: "url(#paint93_linear_150_397)"
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M273.827 104.723C273.747 104.337 273.157 102.957 272.525 103.216C271.892 103.475 271.798 103.701 271.845 103.937C271.892 104.172 272.298 105.51 273.006 105.51C273.709 105.51 273.889 105.02 273.827 104.723Z",
    fill: "url(#paint94_linear_150_397)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M273.775 105.119C273.775 105.119 273.379 105.269 272.803 105.128C272.223 104.987 271.949 104.261 271.949 104.261C271.949 104.261 272.218 105.236 272.699 105.571C273.176 105.9 273.624 105.491 273.78 105.119H273.775Z",
    fill: "#6EE8FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M273.303 103.612C273.7 104.572 273.105 105.5 272.43 104.794C271.746 104.078 271.916 103.503 272.392 103.362C272.869 103.221 273.303 103.612 273.303 103.612Z",
    fill: "#368AA7"
  }))), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M272.949 105.684C272.987 105.59 272.326 105.152 272.326 105.152C272.326 105.152 272.893 105.83 272.949 105.684Z",
    fill: "#DBFFFF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M272.142 98.0543C272.142 98.0543 272.633 97.588 270.533 98.5017C269.844 98.7984 268.777 98.7089 268.216 98.5252C267.272 98.2144 270.283 99.6743 270.429 99.6414C270.575 99.6084 272.142 98.0543 272.142 98.0543Z",
    fill: "#DBFFFF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M264.403 89.3087C264.403 89.3087 264.728 89.4594 263.751 89.7137C262.713 89.9869 262.095 89.5348 262.095 89.5348C262.095 89.5348 263.162 88.9791 264.403 89.3087Z",
    fill: "#DBFFFF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M276.399 94.4656C276.508 94.7576 277.669 94.4326 277.612 94.2631C277.56 94.0936 276.635 93.3918 276.168 93.2741C275.795 93.1799 276.395 94.4656 276.395 94.4656H276.399Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M276.607 109.579C273.445 108.166 266.597 107.214 266.102 107.059C264.79 106.649 271.618 109.513 275.337 109.903C278.315 110.214 276.607 109.579 276.607 109.579Z",
    fill: "#368AC5"
  }))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M289.599 107.229L292.011 122.756C292.105 123.368 292.034 123.994 291.803 124.574C290.708 127.315 287.324 135.566 285.635 137.096C283.492 139.037 274.176 143.812 272.784 143.275C270.132 142.253 269.542 127.103 270.896 123.858C271.897 121.465 280.288 112.376 282.501 110.002C282.85 109.626 283.266 109.32 283.733 109.098L288.651 106.725C289.056 106.527 289.533 106.781 289.604 107.224L289.599 107.229Z",
    fill: "url(#paint95_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M288.212 110.921C288.009 109.376 284.417 111.425 283.204 112.447C268.268 125.007 272.227 121.381 273.818 135.618C273.832 135.74 273.86 135.862 273.907 135.975C275.592 139.969 282.218 134.242 284.129 133.023C284.309 132.91 284.455 132.759 284.568 132.58C288.259 126.604 291.02 121.023 288.212 110.921Z",
    fill: "#6EF3FF"
  }))), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M271.142 124.041C271.142 124.041 282.723 119.949 284.757 118.64C286.791 117.33 289.241 107.101 289.241 107.101C289.241 107.101 285.116 108.495 283.068 110.049C281.019 111.599 274.228 119.205 271.142 124.041Z",
    fill: "url(#paint96_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M289.047 107.888C289.047 107.888 286.102 117.896 285.375 119.836C284.653 121.781 285.522 136.818 285.522 136.818C285.522 136.818 290.793 127.842 291.61 124.187C292.426 120.533 289.047 107.888 289.047 107.888Z",
    fill: "#368AC5"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M271.142 124.041C275.875 120.213 284.021 115.899 285.946 114.104C287.872 112.31 289.241 107.101 289.241 107.101C289.241 107.101 285.361 108.321 282.558 110.812C274.71 117.797 271.142 124.037 271.142 124.037V124.041Z",
    fill: "url(#paint97_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M289.24 107.106C289.24 107.106 286.942 115.235 285.531 117.641C285.531 117.641 289.391 114.914 289.24 107.106Z",
    fill: "#6EFFFF"
  }))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M281.406 111.618C281.406 111.618 281.236 112.032 282.345 111.429C283.521 110.794 283.695 109.852 283.695 109.852C283.695 109.852 282.251 110.257 281.406 111.613V111.618Z",
    fill: "#6EFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M211.494 112.842C211.362 112.922 210.182 111.283 209.899 109.64C209.611 108.001 210.281 105.674 210.281 105.674L210.998 105.693L212.353 112.951L211.499 112.842H211.494Z",
    fill: "#003E8B"
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M216.232 88.1455L226.218 98.1438C226.615 98.5394 226.893 99.0292 227.035 99.5708C227.695 102.142 229.616 109.918 229.201 111.919C228.677 114.458 224.449 122.85 223.151 123.194C220.683 123.853 212.216 113.167 211.48 110.097C210.937 107.831 212.207 96.8016 212.551 93.91C212.608 93.4532 212.745 93.0105 212.962 92.6007L215.274 88.2821C215.463 87.9242 215.944 87.8535 216.232 88.1408V88.1455Z",
    fill: "url(#paint98_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M217.185 91.5599C216.218 90.5426 214.698 93.9335 214.359 95.3134C210.182 112.324 211.13 107.596 219.838 117.09C219.913 117.17 219.998 117.246 220.093 117.302C223.434 119.308 225.208 111.651 225.949 109.757C226.02 109.583 226.048 109.395 226.034 109.206C225.543 102.919 224.585 97.4091 217.185 91.5599Z",
    fill: "#6EF3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M222.348 122.888C222.348 122.888 219.654 115.677 219.743 113.949C219.833 112.221 223.302 105.863 223.821 106.211C224.34 106.56 227.998 111.232 228.229 112.466C228.465 113.695 224.911 121.936 222.353 122.892L222.348 122.888Z",
    fill: "#368ADD"
  }))), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M211.754 110.101C211.754 110.101 217.988 101.012 218.771 98.9868C219.555 96.9617 215.902 88.2444 215.902 88.2444C215.902 88.2444 213.651 91.4374 212.985 93.6462C212.32 95.855 211.428 104.958 211.749 110.106L211.754 110.101Z",
    fill: "url(#paint99_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.84
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M211.678 110.341C211.678 110.341 216.029 103.899 219.045 98.7749C219.045 98.7749 222.367 103.371 223.684 105.608C223.684 105.608 220.333 111.453 219.404 113.134C219.404 113.134 215.458 112.31 211.678 110.341Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M216.18 88.9132C216.18 88.9132 219.352 97.7341 219.857 99.5238C220.362 101.318 228.974 111.773 228.974 111.773C228.974 111.773 228.035 102.472 226.69 99.3872C225.345 96.3025 216.18 88.9132 216.18 88.9132Z",
    fill: "#368AC5"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M211.754 110.101C213.16 104.822 216.784 97.3856 217.228 95.0685C217.676 92.7467 215.902 88.2444 215.902 88.2444C215.902 88.2444 213.731 91.1784 213.023 94.4704C211.031 103.687 211.754 110.101 211.754 110.101Z",
    fill: "url(#paint100_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.72
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M211.753 110.101C211.753 110.101 219.125 104.351 218.771 98.9868L211.753 110.101Z",
    fill: "#368AFF"
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M211.678 110.341C211.678 110.341 216.973 101.831 219.045 98.7749C219.045 98.7749 215.968 104.012 214.264 106.955C213.155 108.863 211.687 109.451 212.339 110.276C212.82 110.883 211.928 110.148 211.678 110.341Z",
    fill: "#6EFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M219.404 113.134L212.669 110.775C212.669 110.775 218.389 116.153 219.404 113.134Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.55
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M212.792 112.616C211.499 110.737 215.265 114.618 216.128 115.188C216.987 115.762 219.408 119.841 219.045 120.057C218.686 120.269 214.665 115.334 212.792 112.616Z",
    fill: "#0978FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M215.906 88.2444C215.906 88.2444 218.549 95.3605 218.799 97.8518C218.799 97.8518 220.154 93.8299 215.906 88.2444Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M219.404 113.134C219.404 113.134 221.81 108.09 223.684 105.608C223.684 105.608 223.34 111.349 219.404 113.134Z",
    fill: "#6EFFFF"
  }))), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M212.613 95.6572C212.613 95.6572 212.712 96.0481 213.193 95.0262C213.707 93.943 213.339 93.1659 213.339 93.1659C213.339 93.1659 212.504 94.2208 212.613 95.6572Z",
    fill: "#6EFFFF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M222.858 106.937C222.858 106.937 222.589 107.351 222.967 105.726C223.089 105.194 222.882 104.445 222.679 104.068C222.33 103.433 223.778 105.392 223.774 105.5C223.769 105.608 222.863 106.937 222.863 106.937H222.858Z",
    fill: "#DBFFFF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M211.749 110.45C211.452 110.271 211.947 109.159 211.961 109.357C212.046 110.351 212.839 110.709 213.75 111.312C214.109 111.552 211.749 110.45 211.749 110.45Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M223.552 95.8879C224.821 97.8942 226.468 107.53 226.568 108.693C226.667 109.856 224.005 120.641 223.632 121.253C223.259 121.866 219.257 120.01 219.706 120.834C220.149 121.658 222.268 123.114 222.953 122.982C223.637 122.85 228.484 114.811 229.026 112.564C229.574 110.318 227.54 101.163 226.86 99.8392C226.181 98.5159 223.552 95.8879 223.552 95.8879Z",
    fill: "#368ADD"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M211.678 110.341C211.678 110.341 216.029 103.899 219.045 98.7749C219.045 98.7749 222.367 103.371 223.684 105.608C223.684 105.608 220.333 111.453 219.404 113.134C219.404 113.134 215.458 112.31 211.678 110.341Z",
    fill: "url(#paint101_linear_150_397)"
  }), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M221.4 103.235C221.136 102.882 220.305 101.436 220.734 101.262C221.164 101.087 221.371 101.21 221.532 101.426C221.692 101.643 222.561 102.943 222.301 103.367C222.042 103.791 221.598 103.503 221.4 103.23V103.235Z",
    fill: "url(#paint102_linear_150_397)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M221.716 103.517C221.716 103.517 221.98 103.4 222.084 102.943C222.193 102.486 221.744 101.747 221.744 101.747C221.744 101.747 222.386 102.684 222.462 103.235C222.537 103.781 222.056 103.72 221.716 103.517Z",
    fill: "#6EE8FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M220.749 102.039C221.334 103.037 222.263 103.419 221.976 102.458C221.683 101.483 221.183 101.125 220.9 101.299C220.616 101.474 220.749 102.039 220.749 102.039Z",
    fill: "#368AA7"
  }))), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M222.452 103.475C222.367 103.423 222.278 102.684 222.278 102.684C222.278 102.684 222.584 103.56 222.452 103.475Z",
    fill: "#DBFFFF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M218.446 99.6839L219.573 99.5049C219.309 98.5159 218.795 97.1501 218.795 97.1501C218.795 97.1501 218.479 98.1721 218.45 99.6839H218.446Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M276.899 102.717L275.181 108.703L269.868 109.093L265.894 110.177L259.98 97.9978C259.98 97.9978 267.678 101.294 268.202 101.407C268.725 101.521 272.784 104.709 273.879 104.666C274.974 104.619 276.904 102.717 276.904 102.717H276.899Z",
    fill: "#003E8B"
  }))), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M199.276 125.308C199.021 124.461 199.195 123.575 199.715 123.034C205.675 116.803 212.542 115.494 213.953 115.918C215.369 116.346 224.373 123.943 224.538 125.53C224.699 127.06 218.441 137.459 216.596 137.864C214.665 138.288 204.491 135.556 202.928 134.068C201.654 132.853 200.031 127.828 199.276 125.304V125.308Z",
    fill: "url(#paint103_linear_150_397)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M200.97 122.751C200.97 122.751 209.318 123.99 216.109 124.724C216.303 124.743 214.382 116.77 213.726 116.365C211.211 114.806 200.965 122.751 200.965 122.751H200.97Z",
    fill: "url(#paint104_linear_150_397)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M200.97 122.751C200.97 122.751 207.988 120.118 215.199 121.202L213.731 116.365C211.168 115.032 200.97 122.751 200.97 122.751Z",
    fill: "url(#paint105_linear_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M211.376 117.434C209.625 120.613 207.686 123.264 205.628 123.015C202.391 122.629 203.863 123.203 202.136 122.553C200.762 122.035 212.164 115.998 211.376 117.434Z",
    fill: "url(#paint106_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M217.95 124.724C217.469 124.621 216.912 124.47 216.747 124.286C216.435 123.938 216.19 122.417 215.605 121.051C214.996 119.629 214.363 116.497 215.156 116.973L213.92 116.299L215.595 122.77C215.798 123.561 215.35 124.418 214.765 124.352L200.96 122.751L214.132 124.588L214.897 125.139C208.634 123.712 200.96 122.751 200.96 122.751C200.96 122.751 205.132 124.63 206.945 124.555C208.134 124.508 212.41 123.665 215.052 126.005C215.741 126.618 216.251 133.47 216.251 133.47C216.265 126.246 216.312 125.426 216.312 125.426C216.312 125.426 218.313 127.235 220.244 127.31C222.08 127.385 224.137 125.445 224.137 125.445L217.941 124.724H217.95Z",
    fill: "#6EFFFF"
  }))), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M214.208 117.378C214.481 117.307 214.628 116.728 214.538 116.586C214.448 116.445 213.448 116.068 213.108 116.177C212.834 116.266 213.939 117.444 214.212 117.373L214.208 117.378Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M213.929 116.304C213.929 116.304 215.628 120.622 216.204 124.804C216.204 124.804 223.769 125.36 224.156 125.445C224.538 125.53 223.576 123.815 220.786 121.447C217.629 118.767 215.128 116.718 213.934 116.299L213.929 116.304Z",
    fill: "#6EFFFF"
  }))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M254.548 84.1566L257.979 97.7766C258.116 98.3134 258.083 98.8268 257.89 99.2648C256.965 101.342 254.081 107.563 252.481 108.486C250.447 109.659 241.363 111.66 239.919 110.902C237.181 109.461 235.6 96.5568 236.757 94.1173C237.611 92.3182 245.487 86.4737 247.564 84.9572C247.894 84.717 248.291 84.5475 248.744 84.4627L253.548 83.5302C253.944 83.4549 254.445 83.7704 254.544 84.1566H254.548Z",
    fill: "url(#paint107_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M253.392 86.9729C253.085 85.626 249.598 86.5726 248.437 87.1707C234.184 94.5176 237.941 92.3182 240.471 104.671C240.494 104.775 240.527 104.888 240.584 104.992C242.542 108.726 248.852 105.335 250.702 104.723C250.872 104.667 251.014 104.572 251.117 104.445C254.454 100.207 256.875 96.1 253.392 86.9729Z",
    fill: "#6EF3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M239.343 110.111C239.343 110.111 241.146 103.659 242.273 102.66C243.406 101.662 250.542 100.343 250.82 100.946C251.099 101.549 251.745 107.158 251.226 108.09C250.702 109.023 242.349 111.439 239.343 110.111Z",
    fill: "#368ADD"
  }))), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M237.021 94.3245C237.021 94.3245 248.437 93.392 250.405 92.7327C252.373 92.0733 254.18 83.9777 254.18 83.9777C254.18 83.9777 250.112 84.2602 248.144 85.1221C246.181 85.9839 239.824 90.9195 237.021 94.3292V94.3245Z",
    fill: "url(#paint108_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.84
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M236.804 94.4186C236.804 94.4186 244.827 93.7075 250.792 92.808C250.792 92.808 251.165 98.1203 251.061 100.48C251.061 100.48 244.345 101.572 242.448 101.911C242.448 101.911 239.201 98.4547 236.804 94.4186Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M254.034 84.5946C254.034 84.5946 251.707 92.3936 251.103 93.8724C250.499 95.3512 252.349 108.227 252.349 108.227C252.349 108.227 257.083 101.798 257.673 98.8974C258.258 95.9917 254.034 84.5946 254.034 84.5946Z",
    fill: "#368AC5"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M237.021 94.3244C241.547 92.1251 249.485 90.2601 251.311 89.1628C253.137 88.0702 254.18 83.9729 254.18 83.9729C254.18 83.9729 250.348 84.1566 247.682 85.6495C240.22 89.8363 237.021 94.3197 237.021 94.3197V94.3244Z",
    fill: "url(#paint109_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.72
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M237.021 94.3245C237.021 94.3245 247.493 96.2931 250.405 92.7327L237.021 94.3245Z",
    fill: "#368AFF"
  }))), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M236.804 94.4186C236.804 94.4186 246.979 93.1377 250.792 92.808C250.792 92.808 244.704 93.7358 241.306 94.2679C239.102 94.6164 237.351 93.877 237.469 94.8708C237.559 95.6007 237.158 94.4846 236.804 94.4186Z",
    fill: "#6EFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M242.448 101.912L237.483 95.4265C237.483 95.4265 239.659 103.014 242.448 101.912Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.55
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M236.488 96.6463C236.393 94.5223 237.625 99.7264 238.097 100.725C238.569 101.723 238.394 106.042 237.922 105.901C237.45 105.759 236.62 99.7216 236.488 96.6463Z",
    fill: "#0978FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M254.18 83.9777C254.18 83.9777 252.387 90.3308 251.117 92.0545C251.117 92.0545 254.836 90.5898 254.18 83.9777Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M242.448 101.912C242.448 101.912 247.781 100.607 251.061 100.48C251.061 100.48 247.262 103.758 242.448 101.912Z",
    fill: "#6EFFFF"
  }))), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M246.573 86.0781C246.573 86.0781 246.431 86.3889 247.507 86.1252C248.649 85.8426 248.767 85.0891 248.767 85.0891C248.767 85.0891 247.337 85.1174 246.573 86.0781Z",
    fill: "#DBFFFF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M236.808 94.5364C236.634 94.2021 237.776 93.8865 237.672 94.0231C237.153 94.7013 237.686 95.5113 238.187 96.5615C238.385 96.976 236.808 94.5317 236.808 94.5317V94.5364Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M256.819 94.3951C256.809 96.5804 252.548 103.739 251.939 104.53C251.33 105.321 242.278 109.97 241.556 110.068C240.834 110.167 238.154 106.032 238.078 106.875C238.003 107.718 239.135 110.196 239.862 110.624C240.589 111.053 250.051 109.729 251.929 108.754C253.803 107.78 257.418 100.626 257.569 99.3025C257.72 97.9791 256.819 94.3951 256.819 94.3951Z",
    fill: "#368AC5"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M236.804 94.4186C236.804 94.4186 244.827 93.7075 250.792 92.808C250.792 92.808 251.165 98.1203 251.061 100.48C251.061 100.48 244.345 101.572 242.448 101.911C242.448 101.911 239.201 98.4547 236.804 94.4186Z",
    fill: "url(#paint110_linear_150_397)"
  }), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M249.669 92.9116L250.844 93.6463C251.193 92.841 251.528 91.6118 251.528 91.6118C251.528 91.6118 250.613 92.0027 249.669 92.9116Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M256.856 93.3165L257.881 97.2961L257.361 103.922L282.596 113.478L284.186 118.673C284.186 118.673 280.463 126.594 280.028 127.277C279.594 127.96 279.476 132.528 280.028 132.975C280.581 133.423 286.14 134.369 286.239 134.2C286.333 134.03 289.613 132.212 289.613 132.212L288.316 134.982C288.316 134.982 283.511 135.109 279.783 136.677C279.783 136.677 277.876 141.622 277.886 142.489C277.895 143.355 285.956 152.03 286.952 153.142C287.947 154.248 291.053 153.726 291.053 153.726C291.053 153.726 288.485 156.297 286.876 156.556C285.267 156.815 280.599 155.525 280.599 155.525L204.113 134.412L203.575 134.03C203.575 134.03 206.086 132.834 206.383 132.42C206.68 132.005 205.76 129.029 205.812 128.6C205.864 128.167 207.992 123.787 208.299 123.49C208.601 123.194 213.891 119.073 215.203 118.687C216.515 118.301 217.521 117.877 217.521 117.877L212.561 113.577C212.561 113.577 219.493 117.222 220.088 117.302C220.683 117.382 224.755 108.137 225.185 107.351C225.614 106.569 225.364 97.2914 225.364 97.2914C225.364 97.2914 226.577 98.2804 226.789 98.8596C227.002 99.4436 227.511 101.511 227.511 101.511L236.214 96.9146L236.398 96.1093C236.398 96.1093 249.843 98.6948 251.033 98.7749C252.222 98.8549 256.852 93.3165 256.852 93.3165H256.856Z",
    fill: "#003E8B"
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M252.699 97.7436C253.043 97.0042 253.827 96.6133 254.714 96.7452C260.646 97.6211 265.767 100.423 266.446 101.229C267.013 101.897 268.31 109.715 267.315 111.533C266.602 112.838 259.353 115.498 257.144 114.919C255.294 114.434 249.754 109.466 249.395 108.203C248.857 106.282 251.495 100.31 252.699 97.7436Z",
    fill: "url(#paint111_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M266.05 105.006C265.342 100.174 259.589 97.9696 254.813 97.8801C254.502 97.8754 254.237 98.0308 254.115 98.2945C252.095 102.674 249.886 106.376 253.992 110.285C255.686 111.839 257.21 112.847 257.479 112.885C260.825 113.356 267.668 110.276 266.078 105.119C266.069 105.081 266.059 105.043 266.054 105.006H266.05Z",
    fill: "#6EF3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M257.395 114.66C257.395 114.66 258.999 110.37 260.542 108.698C262.076 107.031 264.738 107.243 264.738 107.243C264.738 107.243 267.046 110.436 267.083 111.411C267.121 112.371 260.75 114.962 257.395 114.66Z",
    fill: "#368ADD"
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.407 97.6023C253.407 97.6023 255.327 103.39 260.726 107.252C260.726 107.252 263.44 107.247 264.488 107.04C265.521 106.838 266.13 101.426 266.13 101.426C266.13 101.426 260.136 96.7782 253.402 97.5976L253.407 97.6023Z",
    fill: "url(#paint112_linear_150_397)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M253.19 97.5835C253.19 97.5835 255.323 102.886 260.462 107.37C261.085 107.911 256.993 114.877 256.993 114.877C256.993 114.877 250.16 110.558 249.617 107.77C249.098 105.1 253.19 97.5835 253.19 97.5835Z",
    fill: "#6DBBFF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M253.199 98.0215C253.199 98.0215 255.912 103.532 260.537 107.615C260.537 107.615 256.899 104.408 255.016 102.571C253.029 100.626 252.977 97.9979 252.977 97.9979L253.199 98.0215Z",
    fill: "#6EFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M253.407 97.6023C253.407 97.6023 256.899 97.6258 262.312 101.907C265.625 104.53 263.445 107.252 264.492 107.045C265.526 106.842 266.135 101.431 266.135 101.431C266.135 101.431 260.141 96.7828 253.407 97.6023Z",
    fill: "url(#paint113_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M250.381 104.874C249.754 106.4 249.258 107.365 250.056 108.641C250.83 109.88 251.292 110.134 251.878 110.492C252.453 110.85 250.778 103.899 250.381 104.874Z",
    fill: "#6EF6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M267.319 106.018C267.149 104.233 266.602 109.376 266.366 109.932C266.135 110.488 262.227 113.761 261.34 114.076C260.438 114.392 264.294 113.53 265.988 112.409C267.654 111.307 267.801 111.095 267.319 106.018Z",
    fill: "#368AC5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M266.135 101.431C266.135 101.431 264.879 105.957 264.686 106.503C264.573 106.824 264.318 106.937 264.129 106.974L260.731 107.257C263.421 109.046 264.742 107.243 264.742 107.243C264.742 107.243 266.607 104.332 266.135 101.431Z",
    fill: "#6EFFFF"
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M264.511 100.367C264.511 100.367 264.261 100.353 264.832 100.857C265.427 101.384 265.927 101.29 265.927 101.29C265.927 101.29 265.389 100.569 264.511 100.367Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M257.229 114.472C257.706 113.888 258.645 110.822 259.032 110.233C259.419 109.644 260.467 107.935 260.467 107.935L260.854 108.01C260.854 108.01 259.136 111.17 258.57 112.343C258.008 113.506 257.229 114.476 257.229 114.476V114.472Z",
    fill: "#6EFFFF"
  }))), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M260.009 107.313C260.009 106.955 261.42 106.988 261.43 107.191C261.434 107.393 260.698 108.42 260.231 108.684C259.858 108.896 260.009 107.313 260.009 107.313Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M265.389 100.918C263.185 99.3966 257.786 97.3809 254.384 97.7435C253.652 97.8236 258.777 100.743 259.117 100.96C260.212 101.657 266.182 101.469 265.389 100.918Z",
    fill: "url(#paint114_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M253.18 111.585C255.493 112.282 257.635 113.45 258.352 112.758C259.07 112.07 258.669 113.987 260.127 114.161C261.543 114.335 258.305 115.065 257.163 114.726C255.993 114.378 251.901 111.199 253.175 111.58L253.18 111.585Z",
    fill: "#368AC5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M252.18 102.152C253.421 101.318 257.125 104.45 256.889 103.706C256.649 102.957 255.129 100.96 254.841 99.6792C254.549 98.3746 255.257 97.7624 255.795 97.6635C256.328 97.5646 253.855 97.0418 253.19 97.5787C252.524 98.1156 250.726 102.364 250.58 103.273C250.438 104.177 251.174 102.825 252.18 102.152Z",
    fill: "#6EFFFF"
  }))), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M274.483 131.393C277.466 130.225 283.407 117.274 281.944 113.516C280.708 110.342 274.294 107.12 273.596 107.097C272.897 107.073 259.188 111.123 257.054 113.37C254.921 115.616 254.114 122.346 255.422 124.819C256.729 127.296 271.203 132.679 274.483 131.393Z",
    fill: "url(#paint115_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M257.762 114.684C251.641 123.491 269.943 131.633 274.464 125.318C274.488 125.28 274.516 125.242 274.535 125.205C285.842 106.018 267.182 108.161 258.064 114.382C257.946 114.462 257.843 114.566 257.758 114.684H257.762Z",
    fill: "#6EF3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M274.393 130.305C274.271 130.414 272.222 124.743 272.076 122.096C271.93 119.454 276.687 113.04 277.39 112.574C278.093 112.108 281.321 113.125 281.321 113.125C281.321 113.125 282.199 123.392 274.393 130.305Z",
    fill: "#368ADD"
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M255.37 124.046C255.37 124.046 255.308 116.935 257.786 113.299C257.786 113.299 268.343 109.484 276.848 111.858C276.848 111.858 272.614 119.789 269.953 122.445C269.953 122.445 261.203 124.027 255.37 124.046Z",
    fill: "url(#paint116_linear_150_397)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M259.461 112.663C262.227 112.155 268.088 110.973 275.432 112.4C276.465 112.602 272.501 120.161 270.226 121.286C267.951 122.412 255.37 124.046 255.37 124.046C255.37 124.046 260.537 129.966 273.421 131.332C273.421 131.332 271.651 123.349 271.717 121.776C271.784 120.203 276.517 112.701 277.079 112.131C277.645 111.561 281.123 112.611 281.123 112.611C281.123 112.611 277.149 108.321 273.879 107.657C270.608 106.988 259.466 112.663 259.466 112.663H259.461Z",
    fill: "#6DBBFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M257.786 113.299C257.786 113.299 267.711 110.732 276.847 111.858C276.847 111.858 268.386 110.172 264.775 111.104C261.165 112.037 257.781 113.299 257.781 113.299H257.786Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M255.37 124.046C255.37 124.046 255.308 116.935 257.786 113.299C257.786 113.299 268.343 109.484 276.848 111.858C276.848 111.858 270.373 113.591 264.544 116.907C258.555 120.312 258.14 123.523 255.37 124.046Z",
    fill: "url(#paint117_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M273.058 107.634C273.511 107.813 271.5 108.759 270.495 109.126C268.938 109.696 267.446 109.174 268.475 108.849C270.207 108.307 272.576 107.44 273.063 107.629L273.058 107.634Z",
    fill: "#6EF6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M273.912 128.021C274.988 125.935 280.354 119.125 280.849 116.356C281.345 113.586 281.487 119.746 279.844 123.038C278.207 126.326 275.054 130.122 274.672 130.432C274.289 130.743 273.907 128.021 273.907 128.021H273.912Z",
    fill: "#368ADD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M271.76 121.48C271.76 121.48 275.394 114.1 276.843 111.863C276.843 111.863 279.438 115.432 271.76 121.48Z",
    fill: "#6EFFFF"
  }))), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M277.036 111.924C277.22 112.06 276.281 113.389 276.168 113.318C276.055 113.247 275.941 112.263 276.078 111.792C276.187 111.411 277.036 111.924 277.036 111.924Z",
    fill: "#DBFFFF"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M273.969 116.85C273.152 116.148 271.737 118.221 272.614 119.101C273.497 119.982 274.762 117.533 273.969 116.85Z",
    fill: "url(#paint118_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M273.969 116.85C273.152 116.148 271.746 118.136 272.624 119.016C273.501 119.897 274.757 117.533 273.969 116.85Z",
    fill: "#368AA7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M272.614 119.097C271.737 118.221 273.152 116.144 273.969 116.845C273.988 116.86 274.002 116.874 274.016 116.892C274.172 117.062 274.205 117.321 274.134 117.552C273.945 118.169 273.317 118.781 272.935 118.673C272.496 118.546 272.43 119.016 272.789 119.228C272.728 119.195 272.671 119.153 272.61 119.097H272.614Z",
    fill: "#368AFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.67,
    d: "M273.969 116.85C273.671 116.596 273.294 116.709 272.978 117.001C273.398 116.586 273.884 116.365 274.214 116.619C274.653 116.963 274.36 117.952 273.855 118.668C274.228 118.075 274.393 117.208 273.973 116.85H273.969Z",
    fill: "url(#paint119_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M273.969 116.85C274.276 117.114 274.271 117.646 274.101 118.145C274.214 117.74 274.025 117.166 273.53 117.462C272.978 117.792 272.468 117.962 272.591 117.491C272.93 116.888 273.535 116.473 273.969 116.85Z",
    fill: "#368AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M273.596 107.619C272.944 108.307 271.222 109.494 269.896 109.795C268.574 110.097 260.122 112.244 260.448 112.075C267.928 108.114 274.049 107.144 273.596 107.619Z",
    fill: "#6EF6FF"
  }))), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M227.502 97.4704L231.513 95.384C231.513 95.384 242.056 97.0889 250.197 99.6179L255.044 105.867C255.044 105.867 250.207 118.498 245.261 126.646L243.005 127.14C243.005 127.14 231.348 123.49 224.921 120.283L223.042 118.056C223.042 118.056 224.67 108.123 227.502 97.4656V97.4704Z",
    fill: "url(#paint120_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M227.167 116.996C230.81 118.051 235.058 120.655 238.64 121.814C241.198 122.638 243.977 121.512 245.228 119.139C247.418 114.98 249.82 110.827 250.778 107.351C251.368 105.227 250.665 102.924 248.918 101.577C244.303 98.012 234.954 98.0497 232.33 96.9947C228.38 95.8927 224.557 117.519 227.167 116.996Z",
    fill: "#6EF3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.47
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M250.193 99.9146C250.193 99.9146 246.313 102.769 245.629 103.72C244.945 104.671 254.001 104.911 254.001 104.911L250.193 99.9146Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.84
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M231.306 95.7891C231.306 95.7891 232.023 98.9586 232.769 99.2882C234.779 100.178 244.799 103.612 244.799 103.612L249.853 99.7686C249.853 99.7686 240.966 96.877 231.306 95.7891Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M227.88 97.6163C227.88 97.6163 230.051 99.6179 230.815 100.951C231.58 102.279 227.28 117.853 227.28 117.853L223.165 117.684C223.165 117.684 225.18 106.734 227.88 97.6163Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M235.044 99.9005C243.019 100.979 249.858 99.7686 249.858 99.7686C249.858 99.7686 240.773 96.7592 231.311 95.7891C231.311 95.7891 231.985 99.486 235.048 99.9005H235.044Z",
    fill: "#6EF6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M243.283 103.065L244.676 103.564L249.858 99.7686C249.858 99.7686 246.139 102.072 245.374 102.613C244.605 103.15 243.283 103.07 243.283 103.07V103.065Z",
    fill: "#6EFFFF"
  }))), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M231.985 99.552C236.02 100.023 245.393 104.257 245.393 104.257C245.393 104.257 239.041 118.913 238.187 120.815C238.187 120.815 230.956 118.969 227.747 117.721C227.747 117.721 229.154 110.982 230.371 106.235C231.589 101.483 231.99 99.552 231.99 99.552H231.985Z",
    fill: "url(#paint121_linear_150_397)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M231.985 99.552C236.03 100.023 245.393 104.257 245.393 104.257C245.393 104.257 237.762 106.103 236.252 107.544C229.413 114.081 230.952 118.969 227.743 117.721C227.743 117.721 229.149 110.982 230.367 106.235C231.584 101.483 231.985 99.552 231.985 99.552Z",
    fill: "url(#paint122_linear_150_397)"
  }), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M228.163 97.3573L230.971 95.9539C230.971 95.9539 231.792 98.676 231.627 99.4907C231.457 100.305 231.282 100.032 231.131 100.122C230.98 100.211 228.168 97.3526 228.168 97.3526L228.163 97.3573Z",
    fill: "#6EE8FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M231.985 99.552C231.985 99.552 231.584 101.483 230.367 106.235C229.149 110.987 227.743 117.721 227.743 117.721C227.743 117.721 231.688 101.007 232.476 100.508C234.071 99.5049 245.393 104.257 245.393 104.257L245.237 104.186C243.996 103.63 235.714 99.9853 231.99 99.552H231.985Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M254.407 106.009C248.333 104.374 245.634 105.26 245.634 105.26C241.924 110.633 239.046 119.883 238.635 121.239C236.36 120.373 227.686 118.093 227.686 118.093L225.138 120.377C232.467 123.844 243.005 127.145 243.005 127.145L245.261 126.651C251.915 113.972 254.407 106.009 254.407 106.009Z",
    fill: "#368ADD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M226.714 120.75C223.288 118.673 240.239 123.702 240.664 123.966C241.089 124.23 243.288 123.415 244.171 123.128C245.053 122.841 252.765 110.558 252.765 110.558C252.765 110.558 249.423 120.222 245.256 126.655L243 127.15C243 127.15 230.244 122.897 226.714 120.75Z",
    fill: "#368ADD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.55
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M227.856 98.5158C228.833 99.1563 228.932 100.009 228.724 102.156C228.521 104.304 225.888 108.768 225.543 108.825C225.199 108.882 227.403 98.2191 227.856 98.5158Z",
    fill: "#0978FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.35
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M233.25 100.706C238.649 101.092 240.003 102.255 242.793 103.442C245.586 104.629 242.132 111.368 240.777 112.056C239.423 112.743 230.73 100.522 233.245 100.706H233.25Z",
    fill: "#6EF6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M235.19 96.5708C236.78 96.5802 244.61 98.1297 243.17 98.2144C241.731 98.2945 240.513 98.9067 239.536 98.7607C238.56 98.6147 234.694 96.5661 235.19 96.5708Z",
    fill: "#0978FF"
  }))), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M231.603 102.222C232.344 101.973 233.85 100.117 233.515 100.042C233.179 99.9665 232.547 99.8016 232.217 100.258C231.886 100.711 231.447 102.274 231.603 102.222Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M245.393 104.257C245.393 104.257 239.64 117.279 238.72 119.243C237.8 121.206 227.743 117.721 227.743 117.721C227.743 117.721 231.207 119.638 235.27 120.25C239.003 120.811 241.736 124.381 241.736 124.381C241.736 124.381 239.433 121.866 238.937 121.159C238.437 120.453 239.876 116.827 241.717 114.622C243.562 112.423 245.393 104.257 245.393 104.257Z",
    fill: "#6EFFFF"
  }))), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M245.634 102.703C245.634 102.703 245.436 103.117 246.616 102.566C247.866 101.977 248.107 101.017 248.107 101.017C248.107 101.017 246.592 101.351 245.634 102.703Z",
    fill: "#DBFFFF"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M227.365 101.874C227.408 102.269 226.478 102.637 226.445 102.411C226.412 102.185 226.766 100.814 227.039 100.39C227.261 100.046 227.365 101.874 227.365 101.874Z",
    fill: "#DBFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M227.323 101.346C227.323 101.346 228.167 98.6289 228.705 98.1485C229.243 97.6681 230.848 97.1924 231.391 96.9428C231.938 96.6932 238.078 97.0276 237.696 96.8816C237.313 96.7356 231.301 95.7843 231.301 95.7843L227.941 97.4656L227.318 101.346H227.323Z",
    fill: "#6EF6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M274.172 127.343C273.35 127.974 267.409 121.414 266.621 120.91C265.828 120.406 262.869 118.993 262.241 118.418C261.613 117.849 259.933 111.632 259.981 111.26C260.028 110.888 268.758 107.949 268.758 107.949L267.395 105.858C267.395 105.858 266.05 108.368 265.601 108.495C265.153 108.623 260.136 109.381 259.773 109.513C259.409 109.645 252.179 102.147 252.179 102.147C252.179 102.147 253.114 104.29 253.189 104.775C253.265 105.26 244.591 109.31 243.859 109.612C243.128 109.918 240.584 118.188 240.584 118.188L240.985 122.073L251.674 124.861L274.172 129.147V127.338V127.343Z",
    fill: "#003E8B"
  }))), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M251.481 135.721C247.592 136.263 241.146 131.012 239.659 128.125C238.39 125.657 242.377 114.161 243.491 112.235C244.086 111.208 250.089 107.29 253.501 105.114C254.671 104.37 256.078 104.591 256.507 105.585C258.338 109.809 262.208 119.035 261.878 121.098C261.245 125.045 254.039 135.368 251.481 135.726V135.721Z",
    fill: "url(#paint123_linear_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M247.451 111.067C247.371 111.133 247.281 111.189 247.191 111.246C243.817 113.374 241.217 126.787 241.868 126.637C242.722 129.067 247.927 137.002 252.142 132.029C252.161 132.01 254.138 130.15 254.152 130.126C256.054 127.583 258.853 122.539 259.131 120.707C259.145 120.608 259.141 120.519 259.122 120.425C258.834 119.106 256.3 103.772 247.446 111.067H247.451Z",
    fill: "#6EF3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M250.599 124.381C250.599 124.381 251.495 114.801 255.545 105.637C255.545 105.637 261.024 117.448 261.279 120.524C261.519 123.392 256.092 130.875 256.092 130.875C256.092 130.875 251.561 127.164 250.599 124.385V124.381Z",
    fill: "#368ADD"
  }))), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M239.777 127.263C241.872 126.632 249.735 124.197 249.735 124.197C249.735 124.197 253.407 110.092 253.978 105.999C253.978 105.999 246.568 109.899 243.793 112.899C241.198 115.71 239.777 127.258 239.777 127.258V127.263Z",
    fill: "url(#paint124_linear_150_397)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M240.518 124.635C241.391 118.715 242.798 114.703 243.911 113.233C245.063 111.712 253.322 106.028 253.185 107.073C253.053 108.095 243.251 119.035 242.231 120.844C241.254 122.577 240.518 124.635 240.518 124.635Z",
    fill: "url(#paint125_linear_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M252.368 115.899C254.407 110.765 257.069 111.787 258.182 113.968C259.249 116.054 260.49 119.633 260.858 120.495C261.217 121.343 261.599 119.68 258.862 112.291C255.625 103.56 255.497 104.21 254.879 106.084C254.279 107.888 252.373 115.894 252.373 115.894L252.368 115.899Z",
    fill: "#368ADD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M250.41 121.461C250.358 122.049 249.461 123.778 248.834 123.985C243.633 125.704 239.777 127.263 239.777 127.263C239.777 127.263 244.714 126.175 247.422 125.393C248.135 125.186 248.64 124.974 249.003 124.767C249.046 124.748 249.088 124.724 249.131 124.691C249.225 124.63 249.305 124.574 249.381 124.522C249.674 124.343 249.872 124.305 249.872 124.305C249.872 124.305 253.256 119.351 253.666 116.308C254.105 113.045 253.987 106.004 253.987 106.004C253.987 106.004 251.094 113.52 250.424 121.461H250.41Z",
    fill: "#6EFFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M251.915 115.494C251.415 117.542 249.952 121.381 247.885 123.18C245.912 124.894 239.777 127.268 239.777 127.268C241.872 126.637 249.735 124.202 249.735 124.202C249.735 124.202 250.816 120.048 251.915 115.494Z",
    fill: "url(#paint126_linear_150_397)"
  }), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M243.033 114.123C243.033 114.123 242.972 114.533 243.968 113.643C245.049 112.677 244.992 111.773 244.992 111.773C244.992 111.773 243.548 112.644 243.033 114.123Z",
    fill: "#DBFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M252.241 155.256C253.251 158.949 256.365 158.694 257.224 157.62C258.083 156.547 257.673 153.382 257.272 152.671C256.866 151.96 252.241 155.261 252.241 155.261V155.256Z",
    fill: "#9F008D"
  }))), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M254.714 151.135C258.234 150.886 258.768 156.763 255.049 157.018C251.325 157.277 250.707 151.418 254.714 151.135Z",
    fill: "#860409"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M253.562 154.291C256.686 154.098 256.384 152.322 255.261 151.493C254.138 150.664 252.736 151.969 252.472 152.586C252.212 153.203 252.401 154.366 253.562 154.295V154.291Z",
    fill: "#FFFFC4"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M253.161 154.696C254.794 153.316 257.045 155.854 255.478 156.631C253.912 157.409 251.594 156.024 253.161 154.696Z",
    fill: "#D13700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M222.315 166.926C223.325 170.619 226.44 170.364 227.299 169.291C228.163 168.212 227.747 165.052 227.346 164.341C226.94 163.63 222.315 166.931 222.315 166.931V166.926Z",
    fill: "#9F008D"
  }))), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M224.788 162.81C228.309 162.561 228.842 168.438 225.124 168.693C221.4 168.952 220.782 163.093 224.788 162.81Z",
    fill: "#8D1500"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M223.632 165.961C226.757 165.768 226.454 163.992 225.331 163.164C224.208 162.335 222.806 163.639 222.542 164.256C222.283 164.873 222.471 166.036 223.632 165.966V165.961Z",
    fill: "#FFFFC4"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M223.236 166.371C224.869 164.991 227.12 167.529 225.553 168.306C223.986 169.079 221.669 167.699 223.236 166.371Z",
    fill: "#D13700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M238.687 171.005C239.819 175.14 243.307 174.857 244.27 173.652C245.233 172.446 244.775 168.904 244.322 168.104C243.869 167.303 238.687 171.005 238.687 171.005Z",
    fill: "#9F008D"
  }))), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M241.457 166.39C245.402 166.107 245.997 172.691 241.83 172.978C237.663 173.265 236.969 166.71 241.457 166.39Z",
    fill: "#8D1500"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M240.169 169.922C243.671 169.705 243.331 167.718 242.071 166.79C240.811 165.862 239.239 167.322 238.946 168.01C238.654 168.702 238.866 170.002 240.169 169.922Z",
    fill: "#FFFFC4"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M239.72 170.379C241.547 168.834 244.067 171.678 242.316 172.545C240.565 173.411 237.969 171.862 239.72 170.379Z",
    fill: "#D13700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M252.128 140.6C253.138 144.293 255.87 144.057 257.026 142.795C257.961 141.778 257.564 138.726 257.159 138.01C256.753 137.299 252.128 140.6 252.128 140.6Z",
    fill: "#9F008D"
  }))), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M254.601 136.484C258.121 136.235 258.654 142.112 254.936 142.366C251.217 142.621 250.594 136.767 254.601 136.484Z",
    fill: "#8D1500"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M253.421 139.493C256.507 140.035 256.271 137.666 255.143 136.837C254.02 136.008 252.618 137.313 252.354 137.93C252.09 138.547 252.227 139.286 253.416 139.498L253.421 139.493Z",
    fill: "#FFFFC4"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M252.817 139.955C254.525 138.829 256.691 140.845 255.365 141.975C254.077 143.073 251.25 140.986 252.817 139.955Z",
    fill: "#D13700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M207.317 162.457C208.327 166.149 211.06 165.914 212.216 164.652C213.15 163.634 212.754 160.583 212.348 159.867C211.942 159.156 207.317 162.457 207.317 162.457Z",
    fill: "#9F008D"
  }))), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M209.79 158.341C213.311 158.091 213.844 163.969 210.125 164.223C206.406 164.477 205.783 158.624 209.79 158.341Z",
    fill: "#8D1500"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M208.61 161.35C211.697 161.892 211.461 159.523 210.333 158.694C209.21 157.865 207.808 159.17 207.544 159.787C207.279 160.404 207.416 161.143 208.606 161.355L208.61 161.35Z",
    fill: "#FFFFC4"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M208.006 161.812C209.715 160.686 211.881 162.702 210.555 163.832C209.266 164.93 206.439 162.843 208.006 161.812Z",
    fill: "#D13700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M250.042 67.3012C250.415 72.0955 254.317 72.5193 255.639 71.3938C256.956 70.2682 257.196 66.2698 256.866 65.2902C256.536 64.3154 250.042 67.3012 250.042 67.3012Z",
    fill: "#9F008D"
  }))), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M254.072 62.8036C258.48 63.3216 257.744 70.7062 253.09 70.1457C248.437 69.5853 249.055 62.2102 254.072 62.8036Z",
    fill: "#8D1500"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M251.901 66.4206C255.804 66.9198 255.851 64.6545 254.662 63.3688C253.468 62.0784 251.429 63.3594 250.962 64.0564C250.495 64.7581 250.452 66.2369 251.901 66.4206Z",
    fill: "#FFFFC4"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M251.311 66.8303C253.652 65.5116 255.828 69.1756 253.713 69.7643C251.599 70.353 249.065 68.0972 251.311 66.8303Z",
    fill: "#D13700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M202.088 73.9181C202.386 77.7328 205.113 78.0154 206.487 76.9934C207.596 76.1692 207.78 73.0939 207.52 72.3215C207.256 71.5445 202.093 73.9228 202.093 73.9228L202.088 73.9181Z",
    fill: "#9F008D"
  }))), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M205.297 70.3341C208.804 70.7485 208.219 76.6213 204.519 76.1786C200.819 75.7359 201.31 69.8632 205.297 70.3341Z",
    fill: "#8D1500"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M203.57 73.0703C206.496 74.1818 206.713 71.8082 205.765 70.7815C204.816 69.7548 203.193 70.7721 202.82 71.3278C202.447 71.8835 202.438 72.637 203.57 73.0656V73.0703Z",
    fill: "#FFFFC4"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M202.891 73.4094C204.778 72.6229 206.529 75.0107 205.014 75.8725C203.542 76.7108 201.159 74.13 202.891 73.4094Z",
    fill: "#D13700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M201.177 146.073C202.258 149.765 205.585 149.511 206.51 148.437C207.431 147.358 206.992 144.198 206.558 143.487C206.128 142.776 201.177 146.077 201.177 146.077V146.073Z",
    fill: "#9F008D"
  }))), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M203.82 141.952C207.586 141.702 208.157 147.58 204.179 147.834C200.201 148.093 199.535 142.234 203.82 141.952Z",
    fill: "#8D1500"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M202.589 145.103C205.93 144.909 205.609 143.134 204.405 142.305C203.202 141.476 201.706 142.781 201.423 143.398C201.144 144.015 201.347 145.178 202.589 145.107V145.103Z",
    fill: "#FFFFC4"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M202.164 145.512C203.91 144.132 206.312 146.671 204.641 147.448C202.971 148.22 200.488 146.84 202.164 145.512Z",
    fill: "#D13700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M198.403 133.239C199.483 136.931 202.81 136.677 203.735 135.603C204.656 134.525 204.217 131.365 203.783 130.654C203.348 129.943 198.403 133.244 198.403 133.244V133.239Z",
    fill: "#9F008D"
  }))), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M201.045 129.118C204.811 128.869 205.382 134.746 201.404 135.001C197.426 135.255 196.76 129.401 201.045 129.118Z",
    fill: "#8D1500"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M199.814 132.274C203.155 132.081 202.834 130.305 201.631 129.476C200.427 128.647 198.931 129.952 198.648 130.569C198.365 131.186 198.573 132.349 199.814 132.278V132.274Z",
    fill: "#FFFFC4"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M199.389 132.679C201.135 131.299 203.537 133.837 201.867 134.614C200.191 135.387 197.714 134.007 199.389 132.679Z",
    fill: "#D13700"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M262.703 95.8739C262.703 95.8739 262.331 99.0717 260.915 98.8503C260.915 98.8503 262.335 99.0528 262.043 100.635C262.043 100.635 262.335 99.0575 263.751 99.2553C263.751 99.2553 262.331 99.0952 262.703 95.8739Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63,
    d: "M257.314 98.2662C257.191 99.1187 259.315 100.108 262.057 100.489C264.799 100.871 267.177 100.499 267.376 99.6555C267.578 98.7984 265.459 97.7812 262.642 97.3903C259.825 96.9994 257.437 97.3997 257.314 98.2662Z",
    fill: "url(#paint127_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63,
    d: "M263.374 91.3951C262.519 91.2726 261.373 94.5034 260.802 98.6101C260.231 102.717 260.443 106.24 261.278 106.48C262.132 106.725 263.308 103.499 263.893 99.2741C264.478 95.0497 264.242 91.5222 263.374 91.3951Z",
    fill: "url(#paint128_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M267.007 92.9068C266.885 92.8032 264.728 95.384 262.189 98.6713C259.65 101.954 257.635 104.775 257.687 104.968C257.739 105.166 259.9 102.59 262.51 99.2129C265.12 95.8361 267.135 93.0104 267.007 92.9068Z",
    fill: "url(#paint129_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M258.928 92.1298C258.782 92.1958 260.174 95.257 262.033 98.9681C263.893 102.679 265.559 105.717 265.757 105.754C265.96 105.792 264.572 102.731 262.661 98.9163C260.75 95.1015 259.079 92.0639 258.928 92.1298Z",
    fill: "url(#paint130_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M257.154 98.3275C257.13 98.4829 259.395 98.9256 262.213 99.3165C265.035 99.7074 267.404 99.9052 267.508 99.7592C267.616 99.6085 265.351 99.1611 262.453 98.7608C259.551 98.3605 257.182 98.1674 257.154 98.3275Z",
    fill: "url(#paint131_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M263.317 91.3857C263.161 91.3574 262.571 94.6682 262 98.7749C261.429 102.882 261.08 106.329 261.222 106.47C261.363 106.616 261.958 103.31 262.543 99.0857C263.128 94.8613 263.473 91.4139 263.312 91.3857H263.317Z",
    fill: "url(#paint132_radial_150_397)"
  }), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M246.308 82.4564C246.308 82.4564 246.625 85.6589 245.195 85.7437C245.195 85.7437 246.625 85.6401 246.676 87.246C246.676 87.246 246.625 85.6401 248.055 85.5364C248.055 85.5364 246.629 85.6824 246.308 82.4564Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63,
    d: "M241.551 85.9367C241.613 86.7986 243.902 87.3119 246.658 87.1C249.414 86.888 251.665 86.0262 251.679 85.1596C251.693 84.279 249.409 83.7327 246.573 83.9493C243.736 84.1659 241.49 85.0607 241.551 85.932V85.9367Z",
    fill: "url(#paint133_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63,
    d: "M246.011 77.9353C245.147 77.9965 244.718 81.3968 245.034 85.5317C245.35 89.6667 246.304 93.067 247.177 93.1188C248.059 93.1753 248.522 89.775 248.196 85.5223C247.87 81.2696 246.884 77.874 246.011 77.9353Z",
    fill: "url(#paint134_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M249.886 78.6464C249.744 78.5711 248.187 81.5522 246.403 85.301C244.619 89.0498 243.25 92.2287 243.345 92.4076C243.439 92.5913 245.001 89.6149 246.832 85.7625C248.663 81.9101 250.032 78.7218 249.886 78.6511V78.6464Z",
    fill: "url(#paint135_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M241.825 79.5977C241.698 79.6919 243.708 82.3904 246.313 85.6212C248.918 88.8519 251.193 91.4657 251.396 91.461C251.599 91.4563 249.598 88.7577 246.917 85.4375C244.237 82.1126 241.957 79.4988 241.825 79.5977Z",
    fill: "url(#paint136_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M241.41 86.0309C241.419 86.1911 243.727 86.144 246.563 85.9226C249.4 85.706 251.759 85.3952 251.83 85.2303C251.901 85.0608 249.598 85.1032 246.677 85.3292C243.755 85.5506 241.4 85.8661 241.405 86.0309H241.41Z",
    fill: "url(#paint137_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M245.954 77.9399C245.794 77.9447 245.926 81.3025 246.242 85.4422C246.558 89.5772 246.95 93.0198 247.12 93.1282C247.29 93.2412 247.167 89.8833 246.842 85.6306C246.516 81.3779 246.115 77.9352 245.954 77.9399Z",
    fill: "url(#paint138_radial_150_397)"
  }), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M266.828 108.481C266.828 108.481 265.63 111.472 264.322 110.888C264.322 110.888 265.639 111.453 264.945 112.903C264.945 112.903 265.639 111.453 266.956 112.018C266.956 112.018 265.625 111.491 266.828 108.481Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63,
    d: "M261 109.385C260.66 110.177 262.449 111.688 264.992 112.767C267.536 113.845 269.934 114.114 270.344 113.351C270.764 112.578 268.985 111.043 266.371 109.932C263.751 108.82 261.344 108.58 261 109.385Z",
    fill: "url(#paint139_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63,
    d: "M268.65 104.332C267.857 103.988 265.903 106.809 264.28 110.629C262.652 114.443 261.93 117.9 262.68 118.348C263.44 118.804 265.417 115.998 267.093 112.075C268.763 108.152 269.462 104.681 268.655 104.332H268.65Z",
    fill: "url(#paint140_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M271.76 106.743C271.666 106.612 268.909 108.542 265.596 111.048C262.283 113.553 259.603 115.748 259.598 115.951C259.598 116.153 262.359 114.232 265.762 111.655C269.169 109.075 271.85 106.88 271.755 106.743H271.76Z",
    fill: "url(#paint141_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M264.166 103.885C264.011 103.913 264.549 107.228 265.37 111.293C266.191 115.357 267.003 118.724 267.182 118.814C267.366 118.903 266.833 115.588 265.988 111.406C265.143 107.224 264.327 103.856 264.166 103.885Z",
    fill: "url(#paint142_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M260.83 109.404C260.764 109.55 262.836 110.567 265.455 111.679C268.074 112.79 270.311 113.6 270.448 113.487C270.59 113.37 268.522 112.348 265.828 111.203C263.133 110.059 260.896 109.254 260.825 109.404H260.83Z",
    fill: "url(#paint143_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M268.598 104.309C268.452 104.243 267.017 107.28 265.393 111.1C263.765 114.914 262.529 118.15 262.628 118.324C262.727 118.503 264.166 115.465 265.842 111.542C267.512 107.619 268.749 104.379 268.603 104.309H268.598Z",
    fill: "url(#paint144_radial_150_397)"
  }), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M231.99 94.7765C231.99 94.7765 232.032 99.3824 229.984 99.3212C229.984 99.3212 231.91 99.3306 231.881 103.574C231.881 103.574 232.032 99.3589 234.085 99.3918C234.085 99.3918 232.037 99.4201 231.99 94.7765Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63,
    d: "M224.991 99.1187C224.972 100.315 228.068 101.309 231.905 101.356C235.742 101.403 238.956 100.484 239.083 99.293C239.215 98.0779 236.119 97.0418 232.174 96.9947C228.229 96.9476 225.015 97.9036 224.991 99.1187Z",
    fill: "url(#paint145_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63,
    d: "M232.141 88.607C230.942 88.5835 229.927 93.2318 229.857 98.9868C229.786 104.742 230.683 109.55 231.881 109.739C233.094 109.927 234.156 105.283 234.227 99.3636C234.298 93.4484 233.358 88.6306 232.141 88.607Z",
    fill: "url(#paint146_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M237.403 90.067C237.214 89.9493 234.694 93.8723 231.773 98.8315C228.847 103.791 226.563 108.02 226.666 108.279C226.775 108.542 229.3 104.624 232.306 99.5238C235.312 94.4233 237.597 90.1895 237.403 90.067Z",
    fill: "url(#paint147_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M226.152 90.3919C225.963 90.5096 228.408 94.4798 231.612 99.2646C234.817 104.05 237.634 107.944 237.913 107.963C238.196 107.982 235.761 104.007 232.467 99.0857C229.172 94.1642 226.346 90.2741 226.152 90.3919Z",
    fill: "url(#paint148_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M224.783 99.2317C224.774 99.4531 227.969 99.6697 231.919 99.7168C235.869 99.7639 239.163 99.6273 239.286 99.4107C239.409 99.1893 236.214 98.9633 232.15 98.9115C228.087 98.8597 224.788 99.0056 224.783 99.2317Z",
    fill: "url(#paint149_radial_150_397)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M232.061 88.6071C231.839 88.5977 231.603 93.2554 231.532 99.0057C231.461 104.761 231.579 109.56 231.801 109.734C232.023 109.908 232.268 105.255 232.339 99.3401C232.41 93.4249 232.287 88.6165 232.061 88.6071Z",
    fill: "url(#paint150_radial_150_397)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.91
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M206.732 79.2021C206.949 79.4611 206.916 79.8426 206.661 80.0639C206.402 80.2806 206.019 80.2476 205.798 79.9933C205.58 79.7343 205.613 79.3528 205.868 79.1315C206.128 78.9148 206.51 78.9478 206.732 79.2021Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M212.155 74.6291C214.906 77.874 214.5 82.7248 211.248 85.4705C207.997 88.2161 203.136 87.8111 200.384 84.5662C197.633 81.3214 198.039 76.4706 201.291 73.7249C204.542 70.9793 209.403 71.3843 212.155 74.6291Z",
    fill: "url(#paint151_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.54
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M284.502 95.3087C284.526 95.3934 284.474 95.4782 284.389 95.5018C284.304 95.5253 284.219 95.4735 284.195 95.3887C284.172 95.304 284.224 95.2192 284.309 95.1956C284.394 95.1721 284.479 95.2239 284.502 95.3087Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M290.543 93.6651C291.477 97.0795 289.462 100.597 286.041 101.53C282.619 102.462 279.094 100.451 278.159 97.0371C277.225 93.6227 279.24 90.1047 282.661 89.1722C286.083 88.2397 289.608 90.2507 290.543 93.6651Z",
    fill: "url(#paint152_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.54
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M224.916 103.169C224.949 103.282 224.878 103.4 224.765 103.428C224.651 103.461 224.533 103.39 224.505 103.277C224.477 103.164 224.543 103.046 224.656 103.018C224.769 102.99 224.887 103.056 224.916 103.169Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M233.033 100.955C234.288 105.542 231.579 110.276 226.983 111.528C222.386 112.781 217.643 110.078 216.388 105.491C215.132 100.904 217.841 96.1705 222.438 94.9178C227.035 93.665 231.778 96.3683 233.033 100.955Z",
    fill: "url(#paint153_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.54
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M256.12 110.464C256.153 110.577 256.082 110.695 255.969 110.723C255.856 110.756 255.738 110.685 255.709 110.572C255.681 110.459 255.747 110.341 255.86 110.313C255.974 110.28 256.092 110.351 256.12 110.464Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M264.233 108.25C265.488 112.837 262.779 117.571 258.182 118.823C253.586 120.076 248.843 117.373 247.587 112.786C246.332 108.199 249.041 103.466 253.638 102.213C258.234 100.96 262.977 103.663 264.233 108.25Z",
    fill: "url(#paint154_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.54
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M255.974 79.2586C256.007 79.3716 255.936 79.4893 255.823 79.5176C255.71 79.5506 255.592 79.4799 255.563 79.3669C255.53 79.2539 255.601 79.1361 255.714 79.1079C255.828 79.0749 255.946 79.1455 255.974 79.2586Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M264.086 77.0499C265.342 81.6369 262.633 86.37 258.036 87.6227C253.44 88.8755 248.697 86.1722 247.441 81.5851C246.186 76.998 248.895 72.265 253.491 71.0122C258.088 69.7595 262.831 72.4628 264.086 77.0499Z",
    fill: "url(#paint155_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.92
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M237.71 99.2364C237.752 99.3965 237.658 99.566 237.497 99.6084C237.337 99.6508 237.167 99.5566 237.125 99.3965C237.082 99.2364 237.177 99.0668 237.337 99.0244C237.497 98.982 237.667 99.0762 237.71 99.2364Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M248.574 107.283C252.986 101.133 251.567 92.5778 245.404 88.1748C239.241 83.7718 230.668 85.1881 226.256 91.3381C221.844 97.4882 223.263 106.043 229.426 110.446C235.589 114.849 244.161 113.433 248.574 107.283Z",
    fill: "url(#paint156_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.92
  }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M251.641 88.6778C251.684 88.8379 251.589 89.0074 251.429 89.0498C251.268 89.0922 251.099 88.998 251.056 88.8379C251.014 88.6778 251.108 88.5082 251.268 88.4658C251.429 88.4234 251.599 88.5176 251.641 88.6778Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M264.792 91.5007C266.311 84.0905 261.523 76.8545 254.097 75.3388C246.671 73.8231 239.42 78.6015 237.901 86.0118C236.382 93.4221 241.171 100.658 248.597 102.174C256.022 103.689 263.273 98.911 264.792 91.5007Z",
    fill: "url(#paint157_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.92
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M276.649 112.399C276.621 112.564 276.465 112.677 276.3 112.649C276.135 112.621 276.022 112.465 276.05 112.301C276.078 112.136 276.234 112.023 276.399 112.051C276.564 112.079 276.678 112.235 276.649 112.399Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M284.224 123.57C290.433 119.231 291.942 110.692 287.595 104.496C283.247 98.2999 274.69 96.7941 268.481 101.132C262.272 105.471 260.763 114.01 265.111 120.206C269.458 126.402 278.016 127.908 284.224 123.57Z",
    fill: "url(#paint158_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M217.148 87.9571C217.275 88.0513 217.299 88.2303 217.204 88.3574C217.11 88.4846 216.931 88.5081 216.803 88.4139C216.676 88.3197 216.652 88.1408 216.747 88.0136C216.841 87.8865 217.02 87.8629 217.148 87.9571Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M220.423 83.5866C222.967 85.4846 223.486 89.0826 221.579 91.6211C219.677 94.1595 216.072 94.6775 213.528 92.7749C210.984 90.877 210.465 87.2789 212.372 84.7404C214.274 82.202 217.879 81.684 220.423 83.5866Z",
    fill: "url(#paint159_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M237.224 115.734C237.299 115.87 237.248 116.045 237.106 116.12C236.969 116.195 236.794 116.144 236.719 116.002C236.643 115.866 236.695 115.691 236.837 115.616C236.974 115.541 237.148 115.593 237.224 115.734Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M242.042 113.158C243.543 115.95 242.491 119.431 239.692 120.928C236.893 122.426 233.406 121.376 231.905 118.583C230.404 115.79 231.457 112.31 234.255 110.812C237.054 109.315 240.542 110.365 242.042 113.158Z",
    fill: "url(#paint160_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M235.015 87.6934C235.143 87.7876 235.166 87.9666 235.072 88.0937C234.977 88.2209 234.798 88.2445 234.671 88.1503C234.543 88.0561 234.52 87.8771 234.614 87.75C234.708 87.6228 234.888 87.5992 235.015 87.6934Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M238.295 83.3229C240.839 85.2209 241.358 88.819 239.451 91.3574C237.545 93.8958 233.944 94.4139 231.4 92.5112C228.856 90.6133 228.337 87.0152 230.244 84.4768C232.146 81.9383 235.751 81.4203 238.295 83.3229Z",
    fill: "url(#paint161_radial_150_397)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M223.892 84.9477C224.014 85.1738 223.929 85.4516 223.703 85.5694C223.476 85.6918 223.198 85.6071 223.08 85.381C222.957 85.1549 223.042 84.8771 223.269 84.7593C223.495 84.6369 223.774 84.7217 223.892 84.9477Z",
    fill: "#A6FFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.88,
    d: "M232.382 87.8671C233.876 82.9622 231.103 77.7772 226.188 76.286C221.273 74.7948 216.077 77.5622 214.583 82.4671C213.088 87.3721 215.861 92.5571 220.777 94.0483C225.692 95.5394 230.888 92.772 232.382 87.8671Z",
    fill: "url(#paint162_radial_150_397)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_150_397)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "url(#paint163_linear_150_397)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "url(#paint164_linear_150_397)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_397",
    x1: 9,
    y1: 32.5,
    x2: 308.926,
    y2: 225.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE2976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487354,
    stopColor: "#E22F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832128,
    stopColor: "#EF5258"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_397",
    x1: 226.926,
    y1: 108.712,
    x2: 240.664,
    y2: 108.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_397",
    x1: 309.921,
    y1: 145.564,
    x2: 202.48,
    y2: 145.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#841318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#93271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5E33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_150_397",
    x1: 250.57,
    y1: 42.9388,
    x2: 262.975,
    y2: 98.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#BA5E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#A9472A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#993022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#8D1F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#861619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#841318"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_150_397",
    x1: 302.964,
    y1: 148.814,
    x2: 203.882,
    y2: 148.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_150_397",
    x1: 303.753,
    y1: 136.437,
    x2: 202.924,
    y2: 136.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_150_397",
    x1: 320.813,
    y1: 71.0404,
    x2: 298.996,
    y2: 71.0404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_150_397",
    x1: 317.023,
    y1: 73.6401,
    x2: 291.124,
    y2: 73.6401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_150_397",
    x1: 302.408,
    y1: 82.8473,
    x2: 222.551,
    y2: 82.8473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_150_397",
    x1: 300.666,
    y1: 85.4093,
    x2: 205.425,
    y2: 85.4093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_150_397",
    x1: 260.613,
    y1: 99.048,
    x2: 260.613,
    y2: 70.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DFAAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9F008D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_150_397",
    x1: 252.515,
    y1: 159.118,
    x2: 252.515,
    y2: 118.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#DFAAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9F008D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_150_397",
    x1: 203.24,
    y1: 53.3232,
    x2: 221.135,
    y2: 74.0773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_150_397",
    x1: 213.495,
    y1: 64.8852,
    x2: 203.306,
    y2: 64.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A18CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#907BA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_150_397",
    x1: 278.556,
    y1: 33.9342,
    x2: 304.452,
    y2: 72.7011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_150_397",
    x1: 242.68,
    y1: 49.9843,
    x2: 260.936,
    y2: 103.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_150_397",
    x1: 316.315,
    y1: 145.211,
    x2: 191.408,
    y2: 145.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_150_397",
    x1: 315.664,
    y1: 126.411,
    x2: 266.857,
    y2: 126.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#773960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_150_397",
    x1: 306.966,
    y1: 109.626,
    x2: 320.461,
    y2: 120.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_150_397",
    x1: 265.172,
    y1: 170.638,
    x2: 306.041,
    y2: 170.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9F1F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_150_397",
    x1: 251.925,
    y1: 54.2464,
    x2: 261.075,
    y2: 63.4114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2C6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_150_397",
    x1: 319.284,
    y1: 102.736,
    x2: 319.284,
    y2: 74.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#9F1F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_150_397",
    x1: 314.041,
    y1: 103.828,
    x2: 292.162,
    y2: 103.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#773960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_150_397",
    x1: 295.281,
    y1: 51.821,
    x2: 272.383,
    y2: 51.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2C6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_150_397",
    x1: 207.006,
    y1: 96.2271,
    x2: 237.076,
    y2: 126.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2C6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_150_397",
    x1: 258.083,
    y1: 160.39,
    x2: 200.191,
    y2: 160.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2C6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_150_397",
    x1: 245.747,
    y1: 70.0186,
    x2: 223.793,
    y2: 70.0186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#773960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_150_397",
    x1: 225.411,
    y1: 63.0391,
    x2: 236.799,
    y2: 74.4457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_150_397",
    x1: 228.79,
    y1: 48.3736,
    x2: 242.74,
    y2: 62.3523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_150_397",
    x1: 226.974,
    y1: 122.977,
    x2: 215.52,
    y2: 122.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_150_397",
    x1: 203.108,
    y1: 64.5696,
    x2: 213.097,
    y2: 74.5746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2C6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_150_397",
    x1: 237.833,
    y1: 54.1804,
    x2: 242.622,
    y2: 58.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A18CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#907BA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_150_397",
    x1: 224.095,
    y1: 58.193,
    x2: 226.934,
    y2: 61.0387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A18CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#907BA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_150_397",
    x1: 226.974,
    y1: 119.939,
    x2: 215.449,
    y2: 119.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A18CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#907BA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_150_397",
    x1: 253.912,
    y1: 145.541,
    x2: 251.061,
    y2: 145.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A18CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#907BA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_150_397",
    x1: 237.696,
    y1: 65.1819,
    x2: 224.633,
    y2: 65.1819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2BEB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2C6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_150_397",
    x1: 242.68,
    y1: 49.9843,
    x2: 260.937,
    y2: 103.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_150_397",
    x1: 196.09,
    y1: 92.5913,
    x2: 283.856,
    y2: 92.5913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C8BDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8D758D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#614161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#472147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D153D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.11 97.1703) rotate(-180) scale(43.6025 17.851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0400FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0300C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#020092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#010065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#010040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#000010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.419 98.103) rotate(-180) scale(43.6025 17.851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#048DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#036DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#025092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#013865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#012340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.185 113.997) rotate(180) scale(46.5915 34.0035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0077FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0072F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0065DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0051AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#003572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#001227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(287.786 119.884) rotate(-92.2547) scale(4.96527 36.7429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#006BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#004B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#003064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#001B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.245 112.609) rotate(-137.02) scale(4.9714 37.4713)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#006BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#004B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#003064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#001B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(302.928 107.573) rotate(-152.049) scale(4.97272 30.5656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#006BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#004B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#003064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#001B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.549 77.5759) rotate(142.008) scale(4.97168 30.5796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#006BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#004B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#003064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#001B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(295.913 118.036) rotate(-114.675) scale(4.96766 30.2292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#006BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#004B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#003064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#001B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(289.967 122.884) rotate(-104.98) scale(4.96655 26.7913)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#006BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#004B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#003064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#001B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.349 85.8972) rotate(-175.17) scale(4.97615 24.8297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#006BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#004B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#003064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#001B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.371 72.8512) rotate(164.641) scale(4.97549 27.5073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#006BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#004B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#003064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#001B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.982 82.047) rotate(122.874) scale(4.9683 29.4529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#006BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#004B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#003064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#001B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.57 106.05) rotate(98.7179) scale(4.96488 28.7005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#006BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#004B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#003064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#001B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(304.111 85.9782) rotate(-164.541) scale(4.33568 4.38489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.834 93.0516) rotate(-164.541) scale(3.61128 3.65226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.062 63.6264) rotate(-164.541) scale(0.699303 0.70724)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.165 85.4168) rotate(170.12) scale(1.04055 1.06621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.785 95.933) rotate(170.12) scale(7.6201 7.80797)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.841 69.7926) rotate(-164.541) scale(1.64247 1.66111)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.545 88.8224) rotate(170.12) scale(0.389322 0.39892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.077 88.3715) rotate(-164.541) scale(0.204412 0.206733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216.751 93.6496) rotate(170.12) scale(1.84751 1.89306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(287.636 100.135) rotate(-164.541) scale(1.83253 1.85333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.153 94.8373) rotate(170.12) scale(0.736168 0.754323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(272.614 91.219) scale(0.0707898 0.0725256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#00C600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#006500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#004000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#002400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#001000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(273.553 72.447) rotate(-164.541) scale(3.55748 3.59786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(281.637 69.9114) rotate(-164.541) scale(0.613235 0.620195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(266.453 109.278) rotate(-151.47) scale(3.23367 3.23001)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(228.269 111.378) rotate(-151.47) scale(3.57783 3.57378)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(252.449 97.4465) rotate(-151.47) scale(1.49494 1.49325)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.029 110.43) rotate(-151.47) scale(0.609449 0.60876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.651 110.053) rotate(-151.47) scale(2.868 2.86475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(241.638 91.5412) rotate(-151.47) scale(2.92536 2.92205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.421 100.565) rotate(170.12) scale(1.2069 1.23666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(269.539 72.8535) rotate(-164.541) scale(0.563029 0.56942)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#0077C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260.471 89.4912) rotate(180) scale(47.9042 17.3204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#04FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#029D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#002D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(276.227 114.74) rotate(180) scale(47.6273 47.0576)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0400FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0300C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#020092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#010065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#010040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#000010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(263.194 110.511) rotate(-180) scale(44.798 47.0576)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#048DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#036DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#025092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#013865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#012340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.771 107.297) rotate(-179.391) scale(41.0194 42.9068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#04FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#03F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#03D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#02A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#015C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#000404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_150_397",
    x1: 285.186,
    y1: 103.941,
    x2: 291.805,
    y2: 115.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#078ADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1390E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#319EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2F9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0D8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_150_397",
    x1: 279.778,
    y1: 105.46,
    x2: 294.848,
    y2: 110.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_150_397",
    x1: 284.245,
    y1: 102.833,
    x2: 289.343,
    y2: 112.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_150_397",
    x1: 290.092,
    y1: 110.997,
    x2: 291.467,
    y2: 111.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_150_397",
    x1: 291.224,
    y1: 110.957,
    x2: 290.277,
    y2: 111.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6EFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_150_397",
    x1: 364.248,
    y1: 71.334,
    x2: 380.335,
    y2: 81.5963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#008AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#249EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_150_397",
    x1: 287.923,
    y1: 119.283,
    x2: 301.329,
    y2: 114.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_150_397",
    x1: 363.908,
    y1: 70.6956,
    x2: 376.177,
    y2: 74.3315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_150_397",
    x1: 394.53,
    y1: -79.3859,
    x2: 388.635,
    y2: -70.1391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_150_397",
    x1: 240.377,
    y1: 101.629,
    x2: 249.086,
    y2: 114.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#008AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#249EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_150_397",
    x1: 201.058,
    y1: 108.538,
    x2: 212.714,
    y2: 108.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_150_397",
    x1: 240.327,
    y1: 101.049,
    x2: 248.294,
    y2: 107.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_150_397",
    x1: 347.159,
    y1: -7.50811,
    x2: 339.831,
    y2: -2.4914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_150_397",
    x1: 267.904,
    y1: 88.4392,
    x2: 269.736,
    y2: 109.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#008AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#339EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_150_397",
    x1: 270.852,
    y1: 88.4497,
    x2: 262.677,
    y2: 98.2095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_150_397",
    x1: 265.419,
    y1: 89.4447,
    x2: 265.791,
    y2: 93.7479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_150_397",
    x1: 270.143,
    y1: 94.5822,
    x2: 270.586,
    y2: 99.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#22BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#40ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_150_397",
    x1: 273.473,
    y1: 105.577,
    x2: 272.89,
    y2: 103.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_150_397",
    x1: 288.65,
    y1: 141.63,
    x2: 276.149,
    y2: 114.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#008AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#299EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_150_397",
    x1: 275.092,
    y1: 113.443,
    x2: 285.686,
    y2: 117.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_150_397",
    x1: 275.092,
    y1: 113.443,
    x2: 285.251,
    y2: 117.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_150_397",
    x1: 234.141,
    y1: 113.724,
    x2: 210.832,
    y2: 100.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#008AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#299EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_150_397",
    x1: 209.343,
    y1: 100.424,
    x2: 219.213,
    y2: 97.7899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_150_397",
    x1: 209.343,
    y1: 100.424,
    x2: 218.808,
    y2: 97.8982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_150_397",
    x1: 212.553,
    y1: 102.846,
    x2: 225.775,
    y2: 110.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#00A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_150_397",
    x1: 245.843,
    y1: 87.1517,
    x2: 244.305,
    y2: 84.9669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_150_397",
    x1: 86.1165,
    y1: 73.6648,
    x2: 85.5892,
    y2: 52.5754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#299EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008AC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_150_397",
    x1: 200.965,
    y1: 120.443,
    x2: 216.124,
    y2: 120.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_150_397",
    x1: 88.3711,
    y1: 58.6701,
    x2: 78.0308,
    y2: 53.4744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_150_397",
    x1: 202.022,
    y1: 120.123,
    x2: 211.414,
    y2: 120.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_150_397",
    x1: 305.934,
    y1: 138.995,
    x2: 298.941,
    y2: 114.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#008AD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1F9EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_150_397",
    x1: 240.911,
    y1: 86.6903,
    x2: 251.146,
    y2: 92.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_150_397",
    x1: 294.244,
    y1: 113.218,
    x2: 304.737,
    y2: 118.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_150_397",
    x1: 295.606,
    y1: 115.546,
    x2: 300.221,
    y2: 133.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#00A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_150_397",
    x1: 249.226,
    y1: 92.7974,
    x2: 250.797,
    y2: 111.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#008AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#249EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_150_397",
    x1: 253.085,
    y1: 98.346,
    x2: 265.486,
    y2: 105.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_150_397",
    x1: 249.533,
    y1: 92.1377,
    x2: 254.081,
    y2: 104.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_150_397",
    x1: 398.517,
    y1: 76.619,
    x2: 387.462,
    y2: 77.5103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_150_397",
    x1: 259.572,
    y1: 114.249,
    x2: 278.801,
    y2: 122.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#078ADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1390E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#319EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2F9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0D8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_150_397",
    x1: 254.455,
    y1: 121.262,
    x2: 277.243,
    y2: 112.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_150_397",
    x1: 257.368,
    y1: 113.804,
    x2: 272.868,
    y2: 120.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_150_397",
    x1: 272.323,
    y1: 118.145,
    x2: 274.401,
    y2: 117.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_150_397",
    x1: 273.946,
    y1: 116.87,
    x2: 273.655,
    y2: 118.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6EFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_150_397",
    x1: 231.582,
    y1: 100.311,
    x2: 249.692,
    y2: 127.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#098ADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#238AF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#299EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_150_397",
    x1: 228.696,
    y1: 107.106,
    x2: 241.705,
    y2: 112.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_150_397",
    x1: 232.167,
    y1: 99.122,
    x2: 238.038,
    y2: 113.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_150_397",
    x1: 351.891,
    y1: 97.4136,
    x2: 368.256,
    y2: 112.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#008AD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#388AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#279EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_150_397",
    x1: 239.772,
    y1: 116.633,
    x2: 253.973,
    y2: 116.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_150_397",
    x1: 353.73,
    y1: 96.9674,
    x2: 358.074,
    y2: 100.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39BDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#217070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#020707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_150_397",
    x1: 356.895,
    y1: 104.244,
    x2: 360.788,
    y2: 107.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#22BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#40ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DFFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(247.154 76.5649) rotate(-172.146) scale(4.7581 1.70948)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(305.176 113.23) rotate(-82.1038) scale(7.21781 1.71292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(413.711 229.069) rotate(-52.3022) scale(7.2142 0.379895)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(553.901 -45.2251) rotate(-116.618) scale(7.2295 0.380976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(271.956 -28.4276) rotate(-172.126) scale(4.94597 0.379696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(560.569 148.952) rotate(-82.1038) scale(7.21603 0.380554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.053 103.123) rotate(175.619) scale(4.76059 1.71028)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.951 81.7173) rotate(-94.3991) scale(7.21941 1.71339)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(538.213 230.964) rotate(-64.5637) scale(7.21851 0.380422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(373.362 -25.4168) rotate(-128.888) scale(7.22167 0.380256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(249.485 218.11) rotate(175.639) scale(4.94733 0.379781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(542.707 59.1359) rotate(-94.3991) scale(7.21583 0.380563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.189 89.0038) rotate(-156.993) scale(4.75677 1.70996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(295.077 131.778) rotate(-66.917) scale(7.21984 1.71244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.267 235.46) rotate(-37.1325) scale(7.21455 0.379499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(526.615 62.1162) rotate(-101.423) scale(7.2217 0.38082)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.875 -3.16635) rotate(-156.993) scale(4.9544 0.380557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(487.067 212.803) rotate(-66.917) scale(7.23059 0.381107)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.713 104.355) rotate(-179.301) scale(6.60119 2.37148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(276.417 100.752) rotate(-89.2985) scale(10.0147 2.37685)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(481.897 251.924) rotate(-59.4778) scale(10.0183 0.527812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(411.074 -22.0441) rotate(-123.805) scale(10.0176 0.527661)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.076 155.633) rotate(-179.301) scale(6.8726 0.527561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(538.184 104.234) rotate(-89.2985) scale(10.0237 0.528661)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#929200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#353500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#181800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.211 79.5292) rotate(-40.1711) scale(7.70001 7.69733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(284.322 95.2894) rotate(-15.2397) scale(6.41739 6.40588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(224.685 103.164) rotate(-15.2397) scale(8.62573 8.61025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.89 110.456) rotate(-15.2397) scale(8.62573 8.61025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.74 79.2575) rotate(-15.2397) scale(8.62573 8.61025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.401 99.3629) rotate(-15.1798) scale(13.7219 13.6973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.32 88.7932) rotate(-15.1798) scale(13.7219 13.6973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(276.291 112.362) rotate(9.73009) scale(13.7231 13.6961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216.982 88.1598) rotate(-53.1227) scale(5.74521 5.74858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.008 115.811) rotate(-28.1703) scale(5.75021 5.74358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.856 87.8937) rotate(-53.1227) scale(5.74521 5.74858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_150_397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.494 85.0833) rotate(-28.1703) scale(9.29751 9.28679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#006DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#003865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#002340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#001424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_150_397",
    x1: 318.431,
    y1: 173.5,
    x2: 299.526,
    y2: -23.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#590080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#581773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_150_397",
    x1: 163.183,
    y1: 288.187,
    x2: 163.183,
    y2: -100.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121042,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_150_397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 140,
    fill: "white",
    transform: "translate(186 43)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_150_397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFlipBack2);
export default __webpack_public_path__ + "static/media/bg-flip-back-2.0726366e05769f018ebdaa2d0ed63ecf.svg";
export { ForwardRef as ReactComponent };